// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AuthControllerLoginData, AuthControllerLoginResponse, AuthControllerLogoutResponse, AuthControllerRefreshResponse, AuthControllerMeResponse, AuthControllerForgotPasswordData, AuthControllerForgotPasswordResponse, AuthControllerResetPasswordData, AuthControllerResetPasswordResponse, AuthControllerChangePasswordData, AuthControllerChangePasswordResponse, AuthControllerMfaSetupResponse, AuthControllerMfaVerifySetupData, AuthControllerMfaVerifySetupResponse, AuthControllerMfaDisableData, AuthControllerMfaDisableResponse, AuthControllerMfaChallengeData, AuthControllerMfaChallengeResponse, AuthControllerMfaStatusResponse, AuthControllerSwitchableUsersResponse, AuthControllerImpersonateData, AuthControllerImpersonateResponse, NotificationControllerFindAllData, NotificationControllerFindAllResponse, NotificationControllerRetryData, NotificationControllerRetryResponse, NotificationControllerGetVapidPublicKeyResponse, NotificationControllerListMineData, NotificationControllerListMineResponse, NotificationControllerUnreadCountResponse, NotificationControllerMarkAllReadResponse, NotificationControllerMarkOneReadData, NotificationControllerMarkOneReadResponse, NotificationControllerTestPushResponse, NotificationControllerSendMockNotificationResponse, NotificationControllerSavePushSubscriptionData, NotificationControllerSavePushSubscriptionResponse, NotificationControllerDeletePushSubscriptionData, NotificationControllerDeletePushSubscriptionResponse, UsersControllerFindAllResponse, UsersControllerCreateData, UsersControllerFindAllPermissionsResponse, UsersControllerFindConsultantsResponse, UsersControllerFindOneData, UsersControllerUpdateData, UsersControllerUpdateOwnProfileData, UsersControllerAssignRoleData, UsersControllerAssignRoleResponse, UsersControllerRemoveRoleData, UsersControllerRemoveRoleResponse, UsersControllerAddOverrideData, UsersControllerAddOverrideResponse, UsersControllerRemoveOverrideData, UsersControllerRemoveOverrideResponse, UsersControllerProvisionCustomerData, RolesControllerFindAllResponse, RolesControllerCreateData, RolesControllerGetAllPermissionsResponse, RolesControllerFindOneData, RolesControllerUpdateRoleData, RolesControllerUpdateRoleResponse, RolesControllerDeleteRoleData, RolesControllerDeleteRoleResponse, RolesControllerAssignPermissionsData, RolesControllerAssignPermissionsResponse, RolesControllerRemovePermissionData, RolesControllerRemovePermissionResponse, CustomersControllerFindAllData, CustomersControllerFindAllResponse, CustomersControllerCreateData, CustomersControllerGetStatsResponse, CustomersControllerFindOneData, CustomersControllerUpdateData, CustomersControllerUploadDocumentData, CustomersControllerUploadDocumentResponse, CustomersControllerGetDocumentUrlData, CustomersControllerGetDocumentUrlResponse, CustomersControllerCreateContactData, CustomersControllerFindContactsData, CustomersControllerFindContactsResponse, CustomersControllerUpdateContactData, CustomersControllerDeleteContactData, CustomersControllerDeleteContactResponse, AuditControllerGetAuditLogData, AuditControllerGetAuditLogResponse, RequestsControllerFindAllData, RequestsControllerFindAllResponse, RequestsControllerCreateData, RequestsControllerGetDashboardStatsResponse, RequestsControllerFeePreviewGetData, RequestsControllerFeePreviewGetResponse, RequestsControllerFeePreviewData, RequestsControllerFeePreviewResponse, RequestsControllerFindOneData, RequestsControllerUpdateData, RequestsControllerRemoveData, RequestsControllerSubmitForInspectionData, RequestsControllerSubmitForApprovalData, RequestsControllerAssignToMeData, RequestsControllerRequestPledgeStudyData, RequestsControllerRequestPledgeStudyResponse, RequestsControllerSubmitPledgeForApprovalData, RequestsControllerSubmitPledgeForApprovalResponse, RequestsControllerApproveData, RequestsControllerRejectData, RequestsControllerResubmitData, RequestsControllerResubmitResponse, RequestsControllerIssuePetData, RequestsControllerIssuePetResponse, RequestsControllerSendToSapData, RequestsControllerSendToSapResponse, RequestsControllerGetRenewalHistoryData, RequestsControllerDownloadData, RequestsControllerDownloadResponse, DocumentsControllerUploadData, DocumentsControllerFindAllData, DocumentsControllerFindAllResponse, DocumentsControllerDeleteData, VehicleLicensesControllerCreateData, VehicleLicensesControllerCreateResponse, VehicleLicensesControllerFindAllData, VehicleLicensesControllerFindAllResponse, VehicleLicensesControllerDeleteData, InspectionsControllerAssignToMeData, InspectionsControllerUpdateData, InspectionsControllerFindOneData, InspectionsControllerUploadAttachmentData, InspectionsControllerDeleteAttachmentData, InspectionsControllerRequestPledgeStudyData, InspectionsControllerSubmitApprovalData, InspectionGlobalControllerListAllResponse, InspectionGlobalControllerFindOneByIdData, InspectionGlobalControllerFindOneByIdResponse, PledgeStudyControllerFeePreviewData, PledgeStudyControllerFeePreviewResponse, PledgeStudyControllerCreateData, PledgeStudyControllerUpdateData, PledgeStudyControllerFindOneData, PledgeStudyControllerFindOneResponse, PledgeStudyControllerUploadAttachmentData, PledgeStudyControllerDeleteAttachmentData, PledgeStudyControllerSubmitApprovalData, PledgeStudyControllerApproveData, PledgeStudyControllerRejectData, PledgeStudyGlobalControllerListAllResponse, PledgeStudyGlobalControllerFindOneByIdData, PledgeStudyGlobalControllerFindOneByIdResponse, PaymentsControllerInitiateData, PaymentsControllerInitiateResponse, PaymentsControllerWebhookData, PaymentsControllerSendPaymentLinkData, PaymentsControllerSendPaymentLinkResponse, PaymentsControllerVerifyCallbackData, PaymentsControllerVerifyCallbackResponse, PaymentsControllerFindOneData, PaymentsControllerFindOneResponse, PaymentsMockControllerMockConfirmData, PaymentsMockControllerMockConfirmResponse, PayTokenControllerPreviewData, PayTokenControllerPreviewResponse, PayTokenControllerInitiateData, PayTokenControllerInitiateResponse, PaymentGatewayConfigControllerListResponse, PaymentGatewayConfigControllerCreateData, PaymentGatewayConfigControllerCreateResponse, PaymentGatewayConfigControllerUpdateData, PaymentGatewayConfigControllerUpdateResponse, PaymentGatewayConfigControllerDeleteData, PaymentGatewayConfigControllerDeleteResponse, PaymentGatewayConfigControllerActivateData, PaymentGatewayConfigControllerActivateResponse, ConfigMgmtControllerListRequestTypesData, ConfigMgmtControllerListRequestTypesResponse, ConfigMgmtControllerCreateRequestTypeData, ConfigMgmtControllerCreateRequestTypeResponse, ConfigMgmtControllerFindRequestTypeData, ConfigMgmtControllerFindRequestTypeResponse, ConfigMgmtControllerUpdateRequestTypeData, ConfigMgmtControllerUpdateRequestTypeResponse, ConfigMgmtControllerListRiskLevelsData, ConfigMgmtControllerListRiskLevelsResponse, ConfigMgmtControllerCreateRiskLevelData, ConfigMgmtControllerCreateRiskLevelResponse, ConfigMgmtControllerUpdateRiskLevelData, ConfigMgmtControllerUpdateRiskLevelResponse, ConfigMgmtControllerDeleteRiskLevelData, ConfigMgmtControllerDeleteRiskLevelResponse, ConfigMgmtControllerListFeeComponentsData, ConfigMgmtControllerListFeeComponentsResponse, ConfigMgmtControllerCreateFeeComponentData, ConfigMgmtControllerCreateFeeComponentResponse, ConfigMgmtControllerUpdateFeeComponentData, ConfigMgmtControllerUpdateFeeComponentResponse, ConfigMgmtControllerDeactivateFeeComponentData, ConfigMgmtControllerDeactivateFeeComponentResponse, ConfigMgmtControllerUpdateFeeAmountsData, ConfigMgmtControllerUpdateFeeAmountsResponse, ConfigMgmtControllerFeePreviewData, ConfigMgmtControllerFeePreviewResponse, ConfigMgmtControllerListAllDocumentTypesResponse, ConfigMgmtControllerCreateMasterDocumentTypeData, ConfigMgmtControllerCreateMasterDocumentTypeResponse, ConfigMgmtControllerUpdateMasterDocumentTypeData, ConfigMgmtControllerUpdateMasterDocumentTypeResponse, ConfigMgmtControllerSoftDeleteDocumentTypeData, ConfigMgmtControllerSoftDeleteDocumentTypeResponse, ConfigMgmtControllerListDocumentTypesData, ConfigMgmtControllerListDocumentTypesResponse, ConfigMgmtControllerAttachDocumentTypeData, ConfigMgmtControllerAttachDocumentTypeResponse, ConfigMgmtControllerUpdateDocumentLinkData, ConfigMgmtControllerUpdateDocumentLinkResponse, ConfigMgmtControllerRemoveDocumentLinkData, ConfigMgmtControllerRemoveDocumentLinkResponse, ConfigMgmtControllerListFeeComponentTypesResponse, ConfigMgmtControllerCreateFeeComponentTypeData, ConfigMgmtControllerCreateFeeComponentTypeResponse, ConfigMgmtControllerUpdateFeeComponentTypeData, ConfigMgmtControllerUpdateFeeComponentTypeResponse, ConfigMgmtControllerDeleteFeeComponentTypeData, ConfigMgmtControllerDeleteFeeComponentTypeResponse, ConfigMgmtControllerListRiskCategoryFeeComponentsData, ConfigMgmtControllerListRiskCategoryFeeComponentsResponse, ConfigMgmtControllerAddFeeComponentToRiskData, ConfigMgmtControllerAddFeeComponentToRiskResponse, ConfigMgmtControllerUpdateRiskCategoryFeeComponentData, ConfigMgmtControllerUpdateRiskCategoryFeeComponentResponse, ConfigMgmtControllerRemoveRiskCategoryFeeComponentData, ConfigMgmtControllerRemoveRiskCategoryFeeComponentResponse, ConfigMgmtControllerListStudyTypesResponse, ConfigMgmtControllerCreateStudyTypeData, ConfigMgmtControllerCreateStudyTypeResponse, ConfigMgmtControllerUpdateStudyTypeData, ConfigMgmtControllerUpdateStudyTypeResponse, ConfigMgmtControllerDeleteStudyTypeData, ConfigMgmtControllerDeleteStudyTypeResponse, ConfigMgmtControllerAddFeeComponentToStudyTypeData, ConfigMgmtControllerAddFeeComponentToStudyTypeResponse, ConfigMgmtControllerRemoveStudyTypeFeeComponentData, ConfigMgmtControllerRemoveStudyTypeFeeComponentResponse, ConfigMgmtControllerListRequiredStudyTypesResponse, ConfigMgmtControllerCreateRequiredStudyTypeData, ConfigMgmtControllerCreateRequiredStudyTypeResponse, ConfigMgmtControllerUpdateRequiredStudyTypeData, ConfigMgmtControllerUpdateRequiredStudyTypeResponse, ConfigMgmtControllerDeleteRequiredStudyTypeData, ConfigMgmtControllerDeleteRequiredStudyTypeResponse, ConfigMgmtControllerListTahseelStudyRequestTypesResponse, ConfigMgmtControllerCreateTahseelStudyRequestTypeData, ConfigMgmtControllerCreateTahseelStudyRequestTypeResponse, ConfigMgmtControllerUpdateTahseelStudyRequestTypeData, ConfigMgmtControllerUpdateTahseelStudyRequestTypeResponse, ConfigMgmtControllerDeleteTahseelStudyRequestTypeData, ConfigMgmtControllerDeleteTahseelStudyRequestTypeResponse, ConfigMgmtControllerListEnvPermitTypesData, ConfigMgmtControllerListEnvPermitTypesResponse, ConfigMgmtControllerCreateEnvPermitTypeData, ConfigMgmtControllerCreateEnvPermitTypeResponse, ConfigMgmtControllerUpdateEnvPermitTypeData, ConfigMgmtControllerUpdateEnvPermitTypeResponse, ConfigMgmtControllerListEnvPermitCategoriesData, ConfigMgmtControllerListEnvPermitCategoriesResponse, ConfigMgmtControllerCreateEnvPermitCategoryData, ConfigMgmtControllerCreateEnvPermitCategoryResponse, ConfigMgmtControllerUpdateEnvPermitCategoryData, ConfigMgmtControllerUpdateEnvPermitCategoryResponse, PledgeStudyConfigControllerListPledgeStudyTypesResponse, PledgeStudyConfigControllerUpdatePledgeStudyTypeData, PledgeStudyConfigControllerUpdatePledgeStudyTypeResponse, PledgeStudyConfigControllerListMeasurementPointsResponse, PledgeStudyConfigControllerCreateMeasurementPointData, PledgeStudyConfigControllerCreateMeasurementPointResponse, PledgeStudyConfigControllerUpdateMeasurementPointData, PledgeStudyConfigControllerUpdateMeasurementPointResponse, ApiClientControllerListResponse, ApiClientControllerCreateData, ApiClientControllerCreateResponse, ApiClientControllerRevokeData, ApiClientControllerRevokeResponse, SurveyControllerFindAllData, SurveyControllerFindAllResponse, SurveyControllerGetSummaryResponse, SurveyControllerFindByPermitIdData, SurveyControllerGetByTokenData, SurveyControllerSubmitData, SurveyControllerSubmitResponse, HealthControllerCheckResponse, ExtensionRequestsControllerCreateData, ExtensionRequestsControllerCreateResponse, ExtensionRequestsControllerFindAllData, ExtensionRequestsControllerFindAllResponse, ExtensionRequestsControllerApproveData, ExtensionRequestsControllerRejectData, LabRequestsControllerCreateData, LabRequestsControllerCreateResponse, LabRequestsControllerFindAllData, LabRequestsControllerFindAllResponse, LabRequestsControllerAssignToMeData, LabRequestsControllerCreateSiteVisitData, LabRequestsControllerCreateReportData, LabRequestsControllerCreateReportResponse, LabRequestsControllerUpdateReportData, LabRequestsControllerSubmitReportData, LabRequestsControllerUploadAttachmentData, LabRequestsControllerDeleteAttachmentData, LabRequestsControllerDeleteAttachmentResponse, LabRequestsControllerGetAttachmentDownloadUrlData, LabRequestsControllerGetAttachmentDownloadUrlResponse, AllLabRequestsControllerGetDashboardStatsResponse, SiteVisitsControllerCreateData, SiteVisitsControllerCreateResponse, SiteVisitsControllerFindAllData, SiteVisitsControllerFindAllResponse, SiteVisitsControllerSubmitForApprovalData, SiteVisitsControllerSubmitForApprovalResponse, SiteVisitsControllerStartData, SiteVisitsControllerRescheduleData, SiteVisitsControllerCompleteData, SiteVisitTokenControllerGetByTokenData, SiteVisitTokenControllerGetByTokenResponse, SiteVisitTokenControllerApproveData, SiteVisitTokenControllerApproveResponse, SiteVisitTokenControllerRescheduleData, SiteVisitTokenControllerRescheduleResponse, MySiteVisitsControllerFindMineResponse, AllSiteVisitsControllerFindAllResponse, StudyReportsControllerCreateData, StudyReportsControllerCreateResponse, StudyReportsControllerFindAllData, StudyReportsControllerFindAllResponse, StudyReportsControllerSubmitData, StudyReportsControllerFindOneData, StudyReportsControllerFindOneResponse, StudyReportsControllerUpdateData, StudyReportsControllerUploadAttachmentData, StudyReportsControllerDeleteAttachmentData, StudyReportsControllerApproveData, StudyReportsControllerRejectData, StudyReportsControllerFindApprovalsData, StudyReportsControllerFindApprovalsResponse, StudyReportsControllerGetAttachmentDownloadUrlData, StudyReportsControllerGetAttachmentDownloadUrlResponse, StudyReportsControllerGetEnvironmentalStudyContractUrlData, StudyReportsControllerGetEnvironmentalStudyContractUrlResponse, AllStudyReportsControllerFindAllResponse, StudyRequestsControllerCreateData, StudyRequestsControllerCreateResponse, StudyRequestsControllerFindAllData, StudyRequestsControllerFindAllResponse, StudyRequestsControllerMockTahseelRequestData, StudyRequestsControllerMockTahseelRequestResponse, StudyRequestsControllerFeePreviewResponse, StudyRequestsControllerGetDashboardStatsResponse, StudyRequestsControllerFindOneData, StudyRequestsControllerAssignConsultantData, StudyRequestsControllerAssignConsultantResponse, StudyRequestsControllerAssignAuthorityData, StudyRequestsControllerAssignAuthorityResponse, StudyRequestsControllerSendToSapData, StudyRequestsControllerSendToSapResponse, StudyRequestsControllerGetAuditLogData, StudyRequestsControllerGetAuditLogResponse, StudyRequestsControllerIssueFinalReportData, StudyRequestsControllerIssueFinalReportResponse, StudyDocumentsControllerListDocumentTypesData, StudyDocumentsControllerListDocumentTypesResponse, StudyDocumentsControllerUploadData, StudyDocumentsControllerFindAllData, StudyDocumentsControllerFindAllResponse, StudyDocumentsControllerDeleteData, TahseelInboundControllerReceiveData, TahseelInboundControllerReceiveResponse, TahseelInboundControllerListAllResponse, TahseelInboundControllerFindLogByIdData, TahseelInboundControllerCreateRequestFromLogData, TahseelInboundControllerCreateRequestFromLogResponse, UserTypesControllerListResponse, UserTypesControllerCreateData, UserTypesControllerCreateResponse, UserTypesControllerUpdateData, UserTypesControllerUpdateResponse, UserTypesControllerSoftDeleteData, UserTypesControllerSoftDeleteResponse } from './types.gen';

/**
 * Login with email and password
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const authControllerLogin = (data: AuthControllerLoginData): CancelablePromise<AuthControllerLoginResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/login',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Logout — revokes refresh token and clears cookie
 * @returns void
 * @throws ApiError
 */
export const authControllerLogout = (): CancelablePromise<AuthControllerLogoutResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/logout'
    });
};

/**
 * Rotate refresh token and issue new access token
 * @returns unknown
 * @throws ApiError
 */
export const authControllerRefresh = (): CancelablePromise<AuthControllerRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/refresh'
    });
};

/**
 * Get current authenticated user
 * @returns unknown
 * @throws ApiError
 */
export const authControllerMe = (): CancelablePromise<AuthControllerMeResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/auth/me'
    });
};

/**
 * Request password reset email
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const authControllerForgotPassword = (data: AuthControllerForgotPasswordData): CancelablePromise<AuthControllerForgotPasswordResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/forgot-password',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Reset password with token
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const authControllerResetPassword = (data: AuthControllerResetPasswordData): CancelablePromise<AuthControllerResetPasswordResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/reset-password',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Change current password
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const authControllerChangePassword = (data: AuthControllerChangePasswordData): CancelablePromise<AuthControllerChangePasswordResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/change-password',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Begin MFA setup — returns QR code
 * @returns unknown
 * @throws ApiError
 */
export const authControllerMfaSetup = (): CancelablePromise<AuthControllerMfaSetupResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/mfa/setup'
    });
};

/**
 * Verify TOTP code and activate MFA
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const authControllerMfaVerifySetup = (data: AuthControllerMfaVerifySetupData): CancelablePromise<AuthControllerMfaVerifySetupResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/mfa/verify-setup',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Disable MFA (requires current TOTP code)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const authControllerMfaDisable = (data: AuthControllerMfaDisableData): CancelablePromise<AuthControllerMfaDisableResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/mfa/disable',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Complete MFA challenge to receive JWT
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const authControllerMfaChallenge = (data: AuthControllerMfaChallengeData): CancelablePromise<AuthControllerMfaChallengeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/mfa/challenge',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Get MFA status for current user
 * @returns unknown
 * @throws ApiError
 */
export const authControllerMfaStatus = (): CancelablePromise<AuthControllerMfaStatusResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/auth/mfa/status'
    });
};

/**
 * List users available for impersonation (dev/QA only)
 * @returns unknown
 * @throws ApiError
 */
export const authControllerSwitchableUsers = (): CancelablePromise<AuthControllerSwitchableUsersResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/auth/switchable-users'
    });
};

/**
 * Impersonate a user — returns short-lived token (dev/QA only)
 * @param data The data for the request.
 * @param data.userId
 * @returns unknown
 * @throws ApiError
 */
export const authControllerImpersonate = (data: AuthControllerImpersonateData): CancelablePromise<AuthControllerImpersonateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/auth/impersonate/{userId}',
        path: {
            userId: data.userId
        }
    });
};

/**
 * List notification logs with pagination (ES_ADMIN only)
 * @param data The data for the request.
 * @param data.status
 * @param data.type
 * @param data.permitId Filter by PermitRequest.id
 * @param data.page
 * @param data.limit
 * @returns unknown
 * @throws ApiError
 */
export const notificationControllerFindAll = (data: NotificationControllerFindAllData = {}): CancelablePromise<NotificationControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/notifications',
        query: {
            status: data.status,
            type: data.type,
            permitId: data.permitId,
            page: data.page,
            limit: data.limit
        }
    });
};

/**
 * Retry a FAILED notification (re-queues it)
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const notificationControllerRetry = (data: NotificationControllerRetryData): CancelablePromise<NotificationControllerRetryResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/notifications/{id}/retry',
        path: {
            id: data.id
        }
    });
};

/**
 * Get the VAPID public key for browser push subscriptions
 * @returns unknown
 * @throws ApiError
 */
export const notificationControllerGetVapidPublicKey = (): CancelablePromise<NotificationControllerGetVapidPublicKeyResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/notifications/vapid-public-key'
    });
};

/**
 * List in-app notifications for the current user
 * @param data The data for the request.
 * @param data.page
 * @param data.limit
 * @param data.read Filter by read status
 * @returns unknown
 * @throws ApiError
 */
export const notificationControllerListMine = (data: NotificationControllerListMineData = {}): CancelablePromise<NotificationControllerListMineResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/notifications/me',
        query: {
            page: data.page,
            limit: data.limit,
            read: data.read
        }
    });
};

/**
 * Get unread in-app notification count for the current user
 * @returns unknown
 * @throws ApiError
 */
export const notificationControllerUnreadCount = (): CancelablePromise<NotificationControllerUnreadCountResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/notifications/me/unread-count'
    });
};

/**
 * Mark all in-app notifications as read for the current user
 * @returns void
 * @throws ApiError
 */
export const notificationControllerMarkAllRead = (): CancelablePromise<NotificationControllerMarkAllReadResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/notifications/me/read-all'
    });
};

/**
 * Mark a single in-app notification as read
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const notificationControllerMarkOneRead = (data: NotificationControllerMarkOneReadData): CancelablePromise<NotificationControllerMarkOneReadResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/notifications/me/{id}/read',
        path: {
            id: data.id
        }
    });
};

/**
 * Send a test push notification to the current user (for debugging)
 * @returns void
 * @throws ApiError
 */
export const notificationControllerTestPush = (): CancelablePromise<NotificationControllerTestPushResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/notifications/me/test-push'
    });
};

/**
 * Send a mock workflow notification to role recipients (dev use only)
 * @returns unknown
 * @throws ApiError
 */
export const notificationControllerSendMockNotification = (): CancelablePromise<NotificationControllerSendMockNotificationResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/notifications/mock'
    });
};

/**
 * Save a browser push subscription for the current user
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const notificationControllerSavePushSubscription = (data: NotificationControllerSavePushSubscriptionData): CancelablePromise<NotificationControllerSavePushSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/notifications/me/push-subscription',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Remove a browser push subscription by endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns void
 * @throws ApiError
 */
export const notificationControllerDeletePushSubscription = (data: NotificationControllerDeletePushSubscriptionData): CancelablePromise<NotificationControllerDeletePushSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/notifications/me/push-subscription',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List all users
 * @returns unknown
 * @throws ApiError
 */
export const usersControllerFindAll = (): CancelablePromise<UsersControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users'
    });
};

/**
 * Create a new user
 * @param data The data for the request.
 * @param data.requestBody
 * @throws ApiError
 */
export const usersControllerCreate = (data: UsersControllerCreateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            409: 'Email already in use'
        }
    });
};

/**
 * List all permissions
 * @returns unknown
 * @throws ApiError
 */
export const usersControllerFindAllPermissions = (): CancelablePromise<UsersControllerFindAllPermissionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/permissions'
    });
};

/**
 * List Beeah/SM Consultant users for assignment pickers
 * Narrower than GET /users -- only requires sm-study:assign-consultant, so roles that can assign a consultant (without full user:view) can populate the picker.
 * @returns unknown
 * @throws ApiError
 */
export const usersControllerFindConsultants = (): CancelablePromise<UsersControllerFindConsultantsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/consultants'
    });
};

/**
 * Get user detail
 * @param data The data for the request.
 * @param data.id User ID
 * @throws ApiError
 */
export const usersControllerFindOne = (data: UsersControllerFindOneData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/{id}',
        path: {
            id: data.id
        },
        errors: {
            404: 'User not found'
        }
    });
};

/**
 * Update user status or name
 * @param data The data for the request.
 * @param data.id User ID
 * @param data.requestBody
 * @throws ApiError
 */
export const usersControllerUpdate = (data: UsersControllerUpdateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/users/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'User not found'
        }
    });
};

/**
 * Update the current user's own profile
 * Any authenticated user can update their own name, username, and phone number. Email cannot be changed here — nobody can change their own email through self-service profile editing. Email changes go through the admin user-management screen instead (PATCH /users/:id, requires the 'user:edit' permission).
 * @param data The data for the request.
 * @param data.requestBody
 * @throws ApiError
 */
export const usersControllerUpdateOwnProfile = (data: UsersControllerUpdateOwnProfileData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/users/me',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            409: 'Username or phone number already in use'
        }
    });
};

/**
 * Assign a role to a user
 * @param data The data for the request.
 * @param data.id User ID
 * @param data.requestBody
 * @returns void Role assigned
 * @throws ApiError
 */
export const usersControllerAssignRole = (data: UsersControllerAssignRoleData): CancelablePromise<UsersControllerAssignRoleResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/{id}/roles',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'User or role not found'
        }
    });
};

/**
 * Remove a role from a user
 * @param data The data for the request.
 * @param data.id User ID
 * @param data.roleId Role ID
 * @returns void Role removed
 * @throws ApiError
 */
export const usersControllerRemoveRole = (data: UsersControllerRemoveRoleData): CancelablePromise<UsersControllerRemoveRoleResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/users/{id}/roles/{roleId}',
        path: {
            id: data.id,
            roleId: data.roleId
        },
        errors: {
            404: 'User or role assignment not found'
        }
    });
};

/**
 * Add a permission override (GRANT or REVOKE) for a user
 * Permissions are embedded in the JWT at issue time. After adding or removing overrides, the affected user must call POST /api/v1/auth/refresh or re-authenticate to receive a JWT with updated permissions. Requests using a stale JWT may have incorrect permissions until the token is refreshed.
 * @param data The data for the request.
 * @param data.id User ID
 * @param data.requestBody
 * @returns void Override applied
 * @throws ApiError
 */
export const usersControllerAddOverride = (data: UsersControllerAddOverrideData): CancelablePromise<UsersControllerAddOverrideResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/{id}/overrides',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'User or permission not found'
        }
    });
};

/**
 * Remove a permission override from a user
 * After removing an override, the affected user must call POST /api/v1/auth/refresh or re-authenticate to receive a JWT that reflects the updated permission set.
 * @param data The data for the request.
 * @param data.id User ID
 * @param data.permissionId Permission ID
 * @returns void Override removed
 * @throws ApiError
 */
export const usersControllerRemoveOverride = (data: UsersControllerRemoveOverrideData): CancelablePromise<UsersControllerRemoveOverrideResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/users/{id}/overrides/{permissionId}',
        path: {
            id: data.id,
            permissionId: data.permissionId
        },
        errors: {
            404: 'Override not found'
        }
    });
};

/**
 * Create portal account for a Contact and link them
 * @param data The data for the request.
 * @param data.requestBody
 * @throws ApiError
 */
export const usersControllerProvisionCustomer = (data: UsersControllerProvisionCustomerData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/provision-customer',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Contact not found',
            409: 'Contact already has account or email in use'
        }
    });
};

/**
 * Upload or replace the current user profile picture
 * @throws ApiError
 */
export const usersControllerUploadAvatar = (): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/me/avatar',
        errors: {
            400: 'File too large',
            422: 'Invalid image type'
        }
    });
};

/**
 * List all roles
 * @returns unknown
 * @throws ApiError
 */
export const rolesControllerFindAll = (): CancelablePromise<RolesControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/roles'
    });
};

/**
 * Create a new role
 * @param data The data for the request.
 * @param data.requestBody
 * @throws ApiError
 */
export const rolesControllerCreate = (data: RolesControllerCreateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/roles',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            409: 'Role name already in use'
        }
    });
};

/**
 * List all available permissions
 * @returns unknown
 * @throws ApiError
 */
export const rolesControllerGetAllPermissions = (): CancelablePromise<RolesControllerGetAllPermissionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/roles/permissions'
    });
};

/**
 * Get role detail with permissions list
 * @param data The data for the request.
 * @param data.id Role ID
 * @throws ApiError
 */
export const rolesControllerFindOne = (data: RolesControllerFindOneData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/roles/{id}',
        path: {
            id: data.id
        },
        errors: {
            404: 'Role not found'
        }
    });
};

/**
 * Update role name and/or description
 * @param data The data for the request.
 * @param data.id Role ID
 * @param data.requestBody
 * @returns unknown Role updated
 * @throws ApiError
 */
export const rolesControllerUpdateRole = (data: RolesControllerUpdateRoleData): CancelablePromise<RolesControllerUpdateRoleResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/users/roles/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Role not found',
            409: 'Role name already in use'
        }
    });
};

/**
 * Delete a role
 * @param data The data for the request.
 * @param data.id Role ID
 * @returns void Role deleted
 * @throws ApiError
 */
export const rolesControllerDeleteRole = (data: RolesControllerDeleteRoleData): CancelablePromise<RolesControllerDeleteRoleResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/users/roles/{id}',
        path: {
            id: data.id
        },
        errors: {
            404: 'Role not found',
            422: 'System role cannot be deleted, or role has active users'
        }
    });
};

/**
 * Assign permissions to a role
 * Assigning permissions affects all users with this role. Those users must call POST /api/v1/auth/refresh or re-authenticate to receive a JWT reflecting the updated permission set.
 * @param data The data for the request.
 * @param data.id Role ID
 * @param data.requestBody
 * @returns void Permissions assigned
 * @throws ApiError
 */
export const rolesControllerAssignPermissions = (data: RolesControllerAssignPermissionsData): CancelablePromise<RolesControllerAssignPermissionsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/roles/{id}/permissions',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Role not found'
        }
    });
};

/**
 * Remove a permission from a role
 * Removing a permission affects all users with this role. Those users must call POST /api/v1/auth/refresh or re-authenticate to receive a JWT reflecting the updated permission set.
 * @param data The data for the request.
 * @param data.id Role ID
 * @param data.permissionId Permission ID
 * @returns void Permission removed
 * @throws ApiError
 */
export const rolesControllerRemovePermission = (data: RolesControllerRemovePermissionData): CancelablePromise<RolesControllerRemovePermissionResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/users/roles/{id}/permissions/{permissionId}',
        path: {
            id: data.id,
            permissionId: data.permissionId
        },
        errors: {
            404: 'Role or permission assignment not found'
        }
    });
};

/**
 * List accounts with primary contact
 * @param data The data for the request.
 * @param data.search Full-text search on account name
 * @param data.status
 * @param data.page
 * @param data.limit
 * @returns unknown
 * @throws ApiError
 */
export const customersControllerFindAll = (data: CustomersControllerFindAllData = {}): CancelablePromise<CustomersControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/customers',
        query: {
            search: data.search,
            status: data.status,
            page: data.page,
            limit: data.limit
        }
    });
};

/**
 * Create a new account
 * @param data The data for the request.
 * @param data.requestBody
 * @throws ApiError
 */
export const customersControllerCreate = (data: CustomersControllerCreateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/customers',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Name too short'
        }
    });
};

/**
 * Get customer statistics
 * @returns unknown
 * @throws ApiError
 */
export const customersControllerGetStats = (): CancelablePromise<CustomersControllerGetStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/customers/stats'
    });
};

/**
 * Get account detail with contacts and permit summary
 * @param data The data for the request.
 * @param data.id Account ID
 * @throws ApiError
 */
export const customersControllerFindOne = (data: CustomersControllerFindOneData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/customers/{id}',
        path: {
            id: data.id
        },
        errors: {
            404: 'Account not found'
        }
    });
};

/**
 * Update account name, accountType, or status
 * Setting status=INACTIVE is blocked when the account has permit requests in a non-terminal status (i.e. not REJECTED, PAID, PERMIT_ISSUED, or SENT_TO_SAP).
 * @param data The data for the request.
 * @param data.id Account ID
 * @param data.requestBody
 * @throws ApiError
 */
export const customersControllerUpdate = (data: CustomersControllerUpdateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/customers/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Account not found',
            422: 'Cannot deactivate account with active permit requests'
        }
    });
};

/**
 * Upload trade license or VAT registration document
 * @param data The data for the request.
 * @param data.id Account ID
 * @param data.type
 * @returns unknown
 * @throws ApiError
 */
export const customersControllerUploadDocument = (data: CustomersControllerUploadDocumentData): CancelablePromise<CustomersControllerUploadDocumentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/customers/{id}/documents/{type}',
        path: {
            id: data.id,
            type: data.type
        }
    });
};

/**
 * Get signed URL for trade license or VAT registration
 * @param data The data for the request.
 * @param data.id Account ID
 * @param data.type
 * @returns unknown
 * @throws ApiError
 */
export const customersControllerGetDocumentUrl = (data: CustomersControllerGetDocumentUrlData): CancelablePromise<CustomersControllerGetDocumentUrlResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/customers/{id}/documents/{type}',
        path: {
            id: data.id,
            type: data.type
        }
    });
};

/**
 * Add a contact to an account
 * If isPrimary=true, all existing primary contacts for this account are demoted first. Contact-to-user linkage (userId field) is managed via the UsersModule.
 * @param data The data for the request.
 * @param data.id Account ID
 * @param data.requestBody
 * @throws ApiError
 */
export const customersControllerCreateContact = (data: CustomersControllerCreateContactData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/customers/{id}/contacts',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Invalid email or missing phone',
            404: 'Account not found'
        }
    });
};

/**
 * List all active contacts for an account
 * @param data The data for the request.
 * @param data.id Account ID
 * @returns unknown
 * @throws ApiError
 */
export const customersControllerFindContacts = (data: CustomersControllerFindContactsData): CancelablePromise<CustomersControllerFindContactsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/customers/{id}/contacts',
        path: {
            id: data.id
        }
    });
};

/**
 * Update a contact
 * If isPrimary=true, all other contacts for this account are demoted first.
 * @param data The data for the request.
 * @param data.id Account ID
 * @param data.contactId Contact ID
 * @param data.requestBody
 * @throws ApiError
 */
export const customersControllerUpdateContact = (data: CustomersControllerUpdateContactData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/customers/{id}/contacts/{contactId}',
        path: {
            id: data.id,
            contactId: data.contactId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Invalid email or empty phone',
            404: 'Account or contact not found'
        }
    });
};

/**
 * Soft-delete a contact
 * Blocked if the contact is the primary contact and other contacts exist — reassign primary first. Also blocked if the contact is referenced by an active permit request.
 * @param data The data for the request.
 * @param data.id Account ID
 * @param data.contactId Contact ID
 * @returns void Contact deleted
 * @throws ApiError
 */
export const customersControllerDeleteContact = (data: CustomersControllerDeleteContactData): CancelablePromise<CustomersControllerDeleteContactResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/customers/{id}/contacts/{contactId}',
        path: {
            id: data.id,
            contactId: data.contactId
        },
        errors: {
            422: 'Primary contact with siblings, or referenced by active permit'
        }
    });
};

/**
 * Get audit log for a permit
 * @param data The data for the request.
 * @param data.permitId
 * @returns unknown
 * @throws ApiError
 */
export const auditControllerGetAuditLog = (data: AuditControllerGetAuditLogData): CancelablePromise<AuditControllerGetAuditLogResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/permits/{permitId}/audit',
        path: {
            permitId: data.permitId
        }
    });
};

/**
 * List permits (customer-scoped for non-staff users)
 * @param data The data for the request.
 * @param data.status
 * @param data.statuses Comma-separated list of RequestStatus values (takes precedence over status)
 * @param data.requestAction
 * @param data.accountId Filter by Account.id
 * @param data.permitTypeCode PermitType.code — e.g. ENV, WASTE, VEH
 * @param data.search Search by referenceNo or account name
 * @param data.page
 * @param data.limit
 * @returns unknown
 * @throws ApiError
 */
export const requestsControllerFindAll = (data: RequestsControllerFindAllData = {}): CancelablePromise<RequestsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/requests',
        query: {
            status: data.status,
            statuses: data.statuses,
            requestAction: data.requestAction,
            accountId: data.accountId,
            permitTypeCode: data.permitTypeCode,
            search: data.search,
            page: data.page,
            limit: data.limit
        }
    });
};

/**
 * Create a new permit request
 * @param data The data for the request.
 * @param data.requestBody
 * @throws ApiError
 */
export const requestsControllerCreate = (data: RequestsControllerCreateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Missing required fields for permit type',
            422: 'PermitType not active'
        }
    });
};

/**
 * Aggregate permit stats for the dashboard (MTD counts, monthly trend)
 * @returns unknown
 * @throws ApiError
 */
export const requestsControllerGetDashboardStats = (): CancelablePromise<RequestsControllerGetDashboardStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/requests/dashboard-stats'
    });
};

/**
 * Compute fee preview without creating a permit record (query params)
 * @param data The data for the request.
 * @param data.requestTypeId
 * @param data.riskCode
 * @param data.requestAction
 * @returns unknown
 * @throws ApiError
 */
export const requestsControllerFeePreviewGet = (data: RequestsControllerFeePreviewGetData): CancelablePromise<RequestsControllerFeePreviewGetResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/requests/fee-preview',
        query: {
            requestTypeId: data.requestTypeId,
            riskCode: data.riskCode,
            requestAction: data.requestAction
        }
    });
};

/**
 * Compute fee preview without creating a permit record
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const requestsControllerFeePreview = (data: RequestsControllerFeePreviewData): CancelablePromise<RequestsControllerFeePreviewResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/fee-preview',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Get permit detail
 * feeBreakdown is stripped unless caller has permit:view:feeBreakdown permission.
 * @param data The data for the request.
 * @param data.id
 * @throws ApiError
 */
export const requestsControllerFindOne = (data: RequestsControllerFindOneData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/requests/{id}',
        path: {
            id: data.id
        },
        errors: {
            404: 'Permit not found'
        }
    });
};

/**
 * Update permit fields (DRAFT only)
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @throws ApiError
 */
export const requestsControllerUpdate = (data: RequestsControllerUpdateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/requests/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Permit not in DRAFT status'
        }
    });
};

/**
 * Delete permit request (DRAFT only)
 * @param data The data for the request.
 * @param data.id
 * @throws ApiError
 */
export const requestsControllerRemove = (data: RequestsControllerRemoveData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/requests/{id}',
        path: {
            id: data.id
        },
        errors: {
            422: 'Permit not in DRAFT status'
        }
    });
};

/**
 * Submit permit for inspection (DRAFT → SUBMITTED_FOR_INSPECTION)
 * @param data The data for the request.
 * @param data.id
 * @throws ApiError
 */
export const requestsControllerSubmitForInspection = (data: RequestsControllerSubmitForInspectionData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/submit-inspection',
        path: {
            id: data.id
        },
        errors: {
            422: 'Invalid status or missing mandatory documents'
        }
    });
};

/**
 * Submit permit for approval
 * Valid from DRAFT or INSPECTION_IN_PROGRESS status.
 * @param data The data for the request.
 * @param data.id
 * @throws ApiError
 */
export const requestsControllerSubmitForApproval = (data: RequestsControllerSubmitForApprovalData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/submit-approval',
        path: {
            id: data.id
        },
        errors: {
            422: 'Invalid status or missing mandatory documents'
        }
    });
};

/**
 * Assign permit to self as inspector (optimistic lock — 409 if already taken)
 * @param data The data for the request.
 * @param data.id
 * @throws ApiError
 */
export const requestsControllerAssignToMe = (data: RequestsControllerAssignToMeData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/assign',
        path: {
            id: data.id
        },
        errors: {
            409: 'Permit already assigned to another inspector'
        }
    });
};

/**
 * Request pledge study (INSPECTION_IN_PROGRESS → PLEDGE_STUDY_REQUEST)
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const requestsControllerRequestPledgeStudy = (data: RequestsControllerRequestPledgeStudyData): CancelablePromise<RequestsControllerRequestPledgeStudyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/request-pledge',
        path: {
            id: data.id
        }
    });
};

/**
 * Submit pledge study for approval (PLEDGE_STUDY_REQUEST → APPROVAL_REQUEST)
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const requestsControllerSubmitPledgeForApproval = (data: RequestsControllerSubmitPledgeForApprovalData): CancelablePromise<RequestsControllerSubmitPledgeForApprovalResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/submit-pledge-approval',
        path: {
            id: data.id
        }
    });
};

/**
 * Approve permit (APPROVAL_REQUEST → PAYMENT_PROCESS)
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @throws ApiError
 */
export const requestsControllerApprove = (data: RequestsControllerApproveData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/approve',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Comments are mandatory',
            422: 'Invalid status transition'
        }
    });
};

/**
 * Reject permit (APPROVAL_REQUEST → REJECTED)
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @throws ApiError
 */
export const requestsControllerReject = (data: RequestsControllerRejectData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/reject',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Comments are mandatory'
        }
    });
};

/**
 * Resubmit rejected permit for approval (REJECTED → APPROVAL_REQUEST)
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const requestsControllerResubmit = (data: RequestsControllerResubmitData): CancelablePromise<RequestsControllerResubmitResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/resubmit',
        path: {
            id: data.id
        }
    });
};

/**
 * Issue permit (PAID → PERMIT_ISSUED)
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const requestsControllerIssuePet = (data: RequestsControllerIssuePetData): CancelablePromise<RequestsControllerIssuePetResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/issue',
        path: {
            id: data.id
        }
    });
};

/**
 * Send permit to SAP (PERMIT_ISSUED → SENT_TO_SAP)
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const requestsControllerSendToSap = (data: RequestsControllerSendToSapData): CancelablePromise<RequestsControllerSendToSapResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/requests/{id}/send-to-sap',
        path: {
            id: data.id
        }
    });
};

/**
 * Get full renewal chain for a permit
 * Returns ordered chain: ancestors (original), current, and subsequent renewals.
 * @param data The data for the request.
 * @param data.id
 * @throws ApiError
 */
export const requestsControllerGetRenewalHistory = (data: RequestsControllerGetRenewalHistoryData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/requests/{id}/renewal-history',
        path: {
            id: data.id
        },
        errors: {
            404: 'Permit not found'
        }
    });
};

/**
 * Get signed download URL for issued permit PDF (15 min expiry)
 * Returns 404 if permit has not yet been issued. Customer role: access restricted to own permit.
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Returns downloadUrl and expiresAt
 * @throws ApiError
 */
export const requestsControllerDownload = (data: RequestsControllerDownloadData): CancelablePromise<RequestsControllerDownloadResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/requests/{id}/download',
        path: {
            id: data.id
        },
        errors: {
            403: 'Customer accessing another customer permit',
            404: 'Permit not issued or PDF not found'
        }
    });
};

/**
 * Upload a document to a permit
 * Requires @fastify/multipart registered. Accepted types: PDF, DOCX, JPEG, PNG (verified by magic bytes). Max size controlled by MAX_FILE_SIZE_MB env var (default 10 MB). Blocked after permit status reaches APPROVED.
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const documentsControllerUpload = (data: DocumentsControllerUploadData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/documents',
        path: {
            permitId: data.permitId
        },
        errors: {
            400: 'File type not allowed or size exceeded',
            422: 'Permit is approved — uploads blocked'
        }
    });
};

/**
 * List documents with signed S3 URLs (15 min expiry)
 * @param data The data for the request.
 * @param data.permitId
 * @returns unknown
 * @throws ApiError
 */
export const documentsControllerFindAll = (data: DocumentsControllerFindAllData): CancelablePromise<DocumentsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/permits/{permitId}/documents',
        path: {
            permitId: data.permitId
        }
    });
};

/**
 * Soft-delete a document (blocked after APPROVED status)
 * @param data The data for the request.
 * @param data.permitId
 * @param data.docId
 * @throws ApiError
 */
export const documentsControllerDelete = (data: DocumentsControllerDeleteData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/permits/{permitId}/documents/{docId}',
        path: {
            permitId: data.permitId,
            docId: data.docId
        },
        errors: {
            422: 'Permit is approved — deletions blocked'
        }
    });
};

/**
 * Add a vehicle license to a permit
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const vehicleLicensesControllerCreate = (data: VehicleLicensesControllerCreateData): CancelablePromise<VehicleLicensesControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/vehicle-licenses',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List vehicle licenses for a permit
 * @param data The data for the request.
 * @param data.permitId
 * @returns unknown
 * @throws ApiError
 */
export const vehicleLicensesControllerFindAll = (data: VehicleLicensesControllerFindAllData): CancelablePromise<VehicleLicensesControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/permits/{permitId}/vehicle-licenses',
        path: {
            permitId: data.permitId
        }
    });
};

/**
 * Delete a vehicle license (DRAFT status only — hard delete)
 * @param data The data for the request.
 * @param data.permitId
 * @param data.licId
 * @throws ApiError
 */
export const vehicleLicensesControllerDelete = (data: VehicleLicensesControllerDeleteData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/permits/{permitId}/vehicle-licenses/{licId}',
        path: {
            permitId: data.permitId,
            licId: data.licId
        },
        errors: {
            422: 'Permit is not in DRAFT status'
        }
    });
};

/**
 * Assign permit to self as inspector — creates Inspection record
 * Optimistic lock: returns 409 if another inspector already claimed it.
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const inspectionsControllerAssignToMe = (data: InspectionsControllerAssignToMeData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/inspections/assign-to-me',
        path: {
            permitId: data.permitId
        },
        errors: {
            409: 'Permit already assigned to another inspector',
            422: 'Permit not in SUBMITTED_FOR_INSPECTION status'
        }
    });
};

/**
 * Update inspection findings and recommendations (IN_PROGRESS only)
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @throws ApiError
 */
export const inspectionsControllerUpdate = (data: InspectionsControllerUpdateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/permits/{permitId}/inspections',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            403: 'Caller is not the assigned inspector',
            422: 'Permit not INSPECTION_IN_PROGRESS or inspection already completed'
        }
    });
};

/**
 * Get inspection with attachments (signed URLs, 15 min TTL)
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const inspectionsControllerFindOne = (data: InspectionsControllerFindOneData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/permits/{permitId}/inspections',
        path: {
            permitId: data.permitId
        },
        errors: {
            404: 'Permit or inspection not found'
        }
    });
};

/**
 * Upload inspection attachment (PDF, JPEG, PNG — verified by magic bytes)
 * Requires @fastify/multipart registered in main.ts.
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const inspectionsControllerUploadAttachment = (data: InspectionsControllerUploadAttachmentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/inspections/attachments',
        path: {
            permitId: data.permitId
        },
        errors: {
            403: 'Caller is not the assigned inspector',
            422: 'Inspection is already completed'
        }
    });
};

/**
 * Hard-delete inspection attachment (IN_PROGRESS only)
 * @param data The data for the request.
 * @param data.permitId
 * @param data.attachmentId
 * @throws ApiError
 */
export const inspectionsControllerDeleteAttachment = (data: InspectionsControllerDeleteAttachmentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/permits/{permitId}/inspections/attachments/{attachmentId}',
        path: {
            permitId: data.permitId,
            attachmentId: data.attachmentId
        },
        errors: {
            403: 'Caller is not the assigned inspector',
            422: 'Inspection is already completed'
        }
    });
};

/**
 * Request pledge study — completes inspection, transitions permit to PLEDGE_STUDY_REQUEST
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const inspectionsControllerRequestPledgeStudy = (data: InspectionsControllerRequestPledgeStudyData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/inspections/request-pledge-study',
        path: {
            permitId: data.permitId
        },
        errors: {
            403: 'Caller is not the assigned inspector',
            422: 'hasPledgeStudy=false or wrong permit status'
        }
    });
};

/**
 * Submit for approval — completes inspection, transitions permit to APPROVAL_REQUEST
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const inspectionsControllerSubmitApproval = (data: InspectionsControllerSubmitApprovalData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/inspections/submit-approval',
        path: {
            permitId: data.permitId
        },
        errors: {
            403: 'Caller is not the assigned inspector',
            422: 'Wrong permit status'
        }
    });
};

/**
 * List all inspections across all permits
 * @returns unknown
 * @throws ApiError
 */
export const inspectionGlobalControllerListAll = (): CancelablePromise<InspectionGlobalControllerListAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/inspections'
    });
};

/**
 * Get inspection detail by ID (includes signed attachment URLs)
 * @param data The data for the request.
 * @param data.inspectionId Inspection UUID
 * @returns unknown
 * @throws ApiError
 */
export const inspectionGlobalControllerFindOneById = (data: InspectionGlobalControllerFindOneByIdData): CancelablePromise<InspectionGlobalControllerFindOneByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/inspections/{inspectionId}',
        path: {
            inspectionId: data.inspectionId
        }
    });
};

/**
 * Preview pledge study fees without persisting (no DB write)
 * @param data The data for the request.
 * @param data.permitId
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyControllerFeePreview = (data: PledgeStudyControllerFeePreviewData): CancelablePromise<PledgeStudyControllerFeePreviewResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/pledge-study/fee-preview',
        path: {
            permitId: data.permitId
        }
    });
};

/**
 * Create pledge study for a permit (PLEDGE_STUDY_REQUEST status only)
 * Fees are NOT calculated at creation — only when submit-approval is called.
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @throws ApiError
 */
export const pledgeStudyControllerCreate = (data: PledgeStudyControllerCreateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/pledge-study',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Permit not in PLEDGE_STUDY_REQUEST or hasPledgeStudy=false'
        }
    });
};

/**
 * Update pledge study (DRAFT only)
 * If measurementPoints is provided, all existing rows are deleted and replaced with fresh unitPriceAtTime.
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @throws ApiError
 */
export const pledgeStudyControllerUpdate = (data: PledgeStudyControllerUpdateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/permits/{permitId}/pledge-study',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Pledge study is not in DRAFT status'
        }
    });
};

/**
 * Get pledge study with measurement points, attachments (signed URLs, 15 min TTL)
 * feeBreakdown is null until submit-approval is called.
 * @param data The data for the request.
 * @param data.permitId
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyControllerFindOne = (data: PledgeStudyControllerFindOneData): CancelablePromise<PledgeStudyControllerFindOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/permits/{permitId}/pledge-study',
        path: {
            permitId: data.permitId
        }
    });
};

/**
 * Upload pledge study attachment (PDF, JPEG, PNG — verified by magic bytes)
 * Requires @fastify/multipart registered in main.ts. DRAFT status only.
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const pledgeStudyControllerUploadAttachment = (data: PledgeStudyControllerUploadAttachmentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/pledge-study/attachments',
        path: {
            permitId: data.permitId
        },
        errors: {
            422: 'Pledge study is not in DRAFT status'
        }
    });
};

/**
 * Hard-delete pledge study attachment (DRAFT status only)
 * @param data The data for the request.
 * @param data.permitId
 * @param data.attachmentId
 * @throws ApiError
 */
export const pledgeStudyControllerDeleteAttachment = (data: PledgeStudyControllerDeleteAttachmentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/permits/{permitId}/pledge-study/attachments/{attachmentId}',
        path: {
            permitId: data.permitId,
            attachmentId: data.attachmentId
        },
        errors: {
            422: 'Pledge study is not in DRAFT status'
        }
    });
};

/**
 * Submit pledge study for approval — freezes fees, transitions permit to APPROVAL_REQUEST
 * QRA/EIA/ERA require a valid ENV permit (PERMIT_ISSUED or SENT_TO_SAP) for the same account.
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const pledgeStudyControllerSubmitApproval = (data: PledgeStudyControllerSubmitApprovalData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/pledge-study/submit-approval',
        path: {
            permitId: data.permitId
        },
        errors: {
            422: 'Wrong status or missing valid ENV permit prerequisite'
        }
    });
};

/**
 * Approve pledge study — sets PledgeStudy.status=APPROVED, permit transitions to APPROVED
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @throws ApiError
 */
export const pledgeStudyControllerApprove = (data: PledgeStudyControllerApproveData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/pledge-study/approve',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Permit or pledge study not in APPROVAL_REQUEST status'
        }
    });
};

/**
 * Reject pledge study — sets PledgeStudy.status=REJECTED, permit back to PLEDGE_STUDY_REQUEST
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @throws ApiError
 */
export const pledgeStudyControllerReject = (data: PledgeStudyControllerRejectData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/pledge-study/reject',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'rejectionReason is missing',
            422: 'Permit or pledge study not in APPROVAL_REQUEST status'
        }
    });
};

/**
 * List all pledge studies across all permits
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyGlobalControllerListAll = (): CancelablePromise<PledgeStudyGlobalControllerListAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/pledge-studies'
    });
};

/**
 * Get pledge study detail by ID (includes signed attachment URLs)
 * @param data The data for the request.
 * @param data.pledgeStudyId Pledge Study UUID
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyGlobalControllerFindOneById = (data: PledgeStudyGlobalControllerFindOneByIdData): CancelablePromise<PledgeStudyGlobalControllerFindOneByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/pledge-studies/{pledgeStudyId}',
        path: {
            pledgeStudyId: data.pledgeStudyId
        }
    });
};

/**
 * Initiate payment for a permit (PAYMENT_PROCESS status only)
 * Idempotent — a second call with an existing PENDING payment returns the same record. Customer role: access restricted to own permit.
 * @param data The data for the request.
 * @param data.permitId
 * @returns unknown Returns payment record and gateway redirect URL
 * @throws ApiError
 */
export const paymentsControllerInitiate = (data: PaymentsControllerInitiateData): CancelablePromise<PaymentsControllerInitiateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/payments/initiate',
        path: {
            permitId: data.permitId
        },
        errors: {
            403: 'Customer accessing a permit they do not own',
            422: 'Permit not in PAYMENT_PROCESS status'
        }
    });
};

/**
 * Payment gateway webhook (PUBLIC — no auth required)
 * Processes success/failure signals from the payment gateway. Always returns 200 to prevent gateway retry storms. In production, validates X-Signature HMAC-SHA256 against the active gateway securityKey. Bypass with SKIP_WEBHOOK_HMAC=true (staging only).
 * @param data The data for the request.
 * @param data.permitId
 * @param data.xSignature HMAC-SHA256 hex digest of the JSON request body using the gateway securityKey
 * @throws ApiError
 */
export const paymentsControllerWebhook = (data: PaymentsControllerWebhookData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/payments/webhook',
        path: {
            permitId: data.permitId
        },
        headers: {
            'x-signature': data.xSignature
        },
        errors: {
            401: 'Missing or invalid HMAC signature (production only)'
        }
    });
};

/**
 * Send payment link to a selected contact
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const paymentsControllerSendPaymentLink = (data: PaymentsControllerSendPaymentLinkData): CancelablePromise<PaymentsControllerSendPaymentLinkResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/payments/send-link',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Verify Tahseel payment callback (PUBLIC — called by frontend after redirect)
 * Frontend calls this after Tahseel redirects back. Validates HMAC signature, confirms payment via SOAP inquiry, and advances permit to PAID on success.
 * @param data The data for the request.
 * @param data.permitId
 * @param data.requestBody
 * @returns unknown { success: boolean, permitId: string }
 * @throws ApiError
 */
export const paymentsControllerVerifyCallback = (data: PaymentsControllerVerifyCallbackData): CancelablePromise<PaymentsControllerVerifyCallbackResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/permits/{permitId}/payments/verify-callback',
        path: {
            permitId: data.permitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            401: 'Invalid payment signature',
            404: 'Payment record not found'
        }
    });
};

/**
 * Get payment record for a permit
 * Customer role: access restricted to own permit.
 * @param data The data for the request.
 * @param data.permitId
 * @returns unknown
 * @throws ApiError
 */
export const paymentsControllerFindOne = (data: PaymentsControllerFindOneData): CancelablePromise<PaymentsControllerFindOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/permits/{permitId}/payments',
        path: {
            permitId: data.permitId
        }
    });
};

/**
 * Simulate a successful payment webhook (development only)
 * Returns 404 in production. Used for local dev and testing without a real gateway.
 * @param data The data for the request.
 * @param data.gatewayRef
 * @returns void Payment confirmed
 * @throws ApiError
 */
export const paymentsMockControllerMockConfirm = (data: PaymentsMockControllerMockConfirmData): CancelablePromise<PaymentsMockControllerMockConfirmResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/payments/mock-confirm/{gatewayRef}',
        path: {
            gatewayRef: data.gatewayRef
        },
        errors: {
            404: 'Endpoint disabled in production'
        }
    });
};

/**
 * Preview payment link details (PUBLIC — no auth)
 * @param data The data for the request.
 * @param data.token
 * @returns unknown Permit reference, amount, entity, expiry
 * @throws ApiError
 */
export const payTokenControllerPreview = (data: PayTokenControllerPreviewData): CancelablePromise<PayTokenControllerPreviewResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/pay/{token}',
        path: {
            token: data.token
        },
        errors: {
            404: 'Token not found or expired'
        }
    });
};

/**
 * Initiate payment via public token (PUBLIC — no auth)
 * @param data The data for the request.
 * @param data.token
 * @returns unknown { gatewayUrl, amount, permitReference }
 * @throws ApiError
 */
export const payTokenControllerInitiate = (data: PayTokenControllerInitiateData): CancelablePromise<PayTokenControllerInitiateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/pay/{token}',
        path: {
            token: data.token
        }
    });
};

/**
 * List all payment gateway configurations (secrets masked)
 * @returns unknown
 * @throws ApiError
 */
export const paymentGatewayConfigControllerList = (): CancelablePromise<PaymentGatewayConfigControllerListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/payment-gateway'
    });
};

/**
 * Create a new payment gateway configuration
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const paymentGatewayConfigControllerCreate = (data: PaymentGatewayConfigControllerCreateData): CancelablePromise<PaymentGatewayConfigControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/payment-gateway',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Update a payment gateway configuration
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const paymentGatewayConfigControllerUpdate = (data: PaymentGatewayConfigControllerUpdateData): CancelablePromise<PaymentGatewayConfigControllerUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/payment-gateway/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Delete an inactive gateway configuration
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const paymentGatewayConfigControllerDelete = (data: PaymentGatewayConfigControllerDeleteData): CancelablePromise<PaymentGatewayConfigControllerDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/payment-gateway/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * Activate this configuration (deactivates all others)
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const paymentGatewayConfigControllerActivate = (data: PaymentGatewayConfigControllerActivateData): CancelablePromise<PaymentGatewayConfigControllerActivateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/payment-gateway/{id}/activate',
        path: {
            id: data.id
        }
    });
};

/**
 * List all request types with counts
 * @param data The data for the request.
 * @param data.licensingAuthority
 * @param data.domain
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListRequestTypes = (data: ConfigMgmtControllerListRequestTypesData = {}): CancelablePromise<ConfigMgmtControllerListRequestTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types',
        query: {
            licensingAuthority: data.licensingAuthority,
            domain: data.domain
        }
    });
};

/**
 * Create request type
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateRequestType = (data: ConfigMgmtControllerCreateRequestTypeData): CancelablePromise<ConfigMgmtControllerCreateRequestTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/request-types',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Get request type detail with all sub-configs
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerFindRequestType = (data: ConfigMgmtControllerFindRequestTypeData): CancelablePromise<ConfigMgmtControllerFindRequestTypeResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * Update request type (deactivate=true to deactivate)
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateRequestType = (data: ConfigMgmtControllerUpdateRequestTypeData): CancelablePromise<ConfigMgmtControllerUpdateRequestTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListRiskLevels = (data: ConfigMgmtControllerListRiskLevelsData): CancelablePromise<ConfigMgmtControllerListRiskLevelsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}/risks',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateRiskLevel = (data: ConfigMgmtControllerCreateRiskLevelData): CancelablePromise<ConfigMgmtControllerCreateRiskLevelResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/request-types/{id}/risks',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.riskId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateRiskLevel = (data: ConfigMgmtControllerUpdateRiskLevelData): CancelablePromise<ConfigMgmtControllerUpdateRiskLevelResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}/risks/{riskId}',
        path: {
            id: data.id,
            riskId: data.riskId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.riskId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerDeleteRiskLevel = (data: ConfigMgmtControllerDeleteRiskLevelData): CancelablePromise<ConfigMgmtControllerDeleteRiskLevelResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/request-types/{id}/risks/{riskId}',
        path: {
            id: data.id,
            riskId: data.riskId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListFeeComponents = (data: ConfigMgmtControllerListFeeComponentsData): CancelablePromise<ConfigMgmtControllerListFeeComponentsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}/fee-components',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateFeeComponent = (data: ConfigMgmtControllerCreateFeeComponentData): CancelablePromise<ConfigMgmtControllerCreateFeeComponentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/request-types/{id}/fee-components',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.componentId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateFeeComponent = (data: ConfigMgmtControllerUpdateFeeComponentData): CancelablePromise<ConfigMgmtControllerUpdateFeeComponentResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}/fee-components/{componentId}',
        path: {
            id: data.id,
            componentId: data.componentId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.componentId
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerDeactivateFeeComponent = (data: ConfigMgmtControllerDeactivateFeeComponentData): CancelablePromise<ConfigMgmtControllerDeactivateFeeComponentResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/request-types/{id}/fee-components/{componentId}',
        path: {
            id: data.id,
            componentId: data.componentId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.componentId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateFeeAmounts = (data: ConfigMgmtControllerUpdateFeeAmountsData): CancelablePromise<ConfigMgmtControllerUpdateFeeAmountsResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}/fee-components/{componentId}/amounts',
        path: {
            id: data.id,
            componentId: data.componentId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Compute fee table for all risk × action combinations (live, no DB write)
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerFeePreview = (data: ConfigMgmtControllerFeePreviewData): CancelablePromise<ConfigMgmtControllerFeePreviewResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}/fee-preview',
        path: {
            id: data.id
        }
    });
};

/**
 * List all master document types
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListAllDocumentTypes = (): CancelablePromise<ConfigMgmtControllerListAllDocumentTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/document-types'
    });
};

/**
 * Create master document type (code auto-generated)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateMasterDocumentType = (data: ConfigMgmtControllerCreateMasterDocumentTypeData): CancelablePromise<ConfigMgmtControllerCreateMasterDocumentTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/document-types',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateMasterDocumentType = (data: ConfigMgmtControllerUpdateMasterDocumentTypeData): CancelablePromise<ConfigMgmtControllerUpdateMasterDocumentTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/document-types/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerSoftDeleteDocumentType = (data: ConfigMgmtControllerSoftDeleteDocumentTypeData): CancelablePromise<ConfigMgmtControllerSoftDeleteDocumentTypeResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/document-types/{id}',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListDocumentTypes = (data: ConfigMgmtControllerListDocumentTypesData): CancelablePromise<ConfigMgmtControllerListDocumentTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}/document-types',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerAttachDocumentType = (data: ConfigMgmtControllerAttachDocumentTypeData): CancelablePromise<ConfigMgmtControllerAttachDocumentTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/request-types/{id}/document-types',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.linkId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateDocumentLink = (data: ConfigMgmtControllerUpdateDocumentLinkData): CancelablePromise<ConfigMgmtControllerUpdateDocumentLinkResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}/document-types/{linkId}',
        path: {
            id: data.id,
            linkId: data.linkId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.linkId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerRemoveDocumentLink = (data: ConfigMgmtControllerRemoveDocumentLinkData): CancelablePromise<ConfigMgmtControllerRemoveDocumentLinkResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/request-types/{id}/document-types/{linkId}',
        path: {
            id: data.id,
            linkId: data.linkId
        }
    });
};

/**
 * List all master fee component types
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListFeeComponentTypes = (): CancelablePromise<ConfigMgmtControllerListFeeComponentTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/fee-component-types'
    });
};

/**
 * Create master fee component type (code auto-generated)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateFeeComponentType = (data: ConfigMgmtControllerCreateFeeComponentTypeData): CancelablePromise<ConfigMgmtControllerCreateFeeComponentTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/fee-component-types',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.typeId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateFeeComponentType = (data: ConfigMgmtControllerUpdateFeeComponentTypeData): CancelablePromise<ConfigMgmtControllerUpdateFeeComponentTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/fee-component-types/{typeId}',
        path: {
            typeId: data.typeId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.typeId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerDeleteFeeComponentType = (data: ConfigMgmtControllerDeleteFeeComponentTypeData): CancelablePromise<ConfigMgmtControllerDeleteFeeComponentTypeResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/fee-component-types/{typeId}',
        path: {
            typeId: data.typeId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.riskId
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListRiskCategoryFeeComponents = (data: ConfigMgmtControllerListRiskCategoryFeeComponentsData): CancelablePromise<ConfigMgmtControllerListRiskCategoryFeeComponentsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}/risks/{riskId}/fee-components',
        path: {
            id: data.id,
            riskId: data.riskId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.riskId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerAddFeeComponentToRisk = (data: ConfigMgmtControllerAddFeeComponentToRiskData): CancelablePromise<ConfigMgmtControllerAddFeeComponentToRiskResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/request-types/{id}/risks/{riskId}/fee-components',
        path: {
            id: data.id,
            riskId: data.riskId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.riskId
 * @param data.linkId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateRiskCategoryFeeComponent = (data: ConfigMgmtControllerUpdateRiskCategoryFeeComponentData): CancelablePromise<ConfigMgmtControllerUpdateRiskCategoryFeeComponentResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}/risks/{riskId}/fee-components/{linkId}',
        path: {
            id: data.id,
            riskId: data.riskId,
            linkId: data.linkId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.riskId
 * @param data.linkId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerRemoveRiskCategoryFeeComponent = (data: ConfigMgmtControllerRemoveRiskCategoryFeeComponentData): CancelablePromise<ConfigMgmtControllerRemoveRiskCategoryFeeComponentResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/request-types/{id}/risks/{riskId}/fee-components/{linkId}',
        path: {
            id: data.id,
            riskId: data.riskId,
            linkId: data.linkId
        }
    });
};

/**
 * List all global study types with fee components
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListStudyTypes = (): CancelablePromise<ConfigMgmtControllerListStudyTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/study-types'
    });
};

/**
 * Create a global study type
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateStudyType = (data: ConfigMgmtControllerCreateStudyTypeData): CancelablePromise<ConfigMgmtControllerCreateStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/study-types',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.studyTypeId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateStudyType = (data: ConfigMgmtControllerUpdateStudyTypeData): CancelablePromise<ConfigMgmtControllerUpdateStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/study-types/{studyTypeId}',
        path: {
            studyTypeId: data.studyTypeId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.studyTypeId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerDeleteStudyType = (data: ConfigMgmtControllerDeleteStudyTypeData): CancelablePromise<ConfigMgmtControllerDeleteStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/study-types/{studyTypeId}',
        path: {
            studyTypeId: data.studyTypeId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.studyTypeId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerAddFeeComponentToStudyType = (data: ConfigMgmtControllerAddFeeComponentToStudyTypeData): CancelablePromise<ConfigMgmtControllerAddFeeComponentToStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/study-types/{studyTypeId}/fee-components',
        path: {
            studyTypeId: data.studyTypeId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.studyTypeId
 * @param data.linkId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerRemoveStudyTypeFeeComponent = (data: ConfigMgmtControllerRemoveStudyTypeFeeComponentData): CancelablePromise<ConfigMgmtControllerRemoveStudyTypeFeeComponentResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/study-types/{studyTypeId}/fee-components/{linkId}',
        path: {
            studyTypeId: data.studyTypeId,
            linkId: data.linkId
        }
    });
};

/**
 * List all global required study types
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListRequiredStudyTypes = (): CancelablePromise<ConfigMgmtControllerListRequiredStudyTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/required-study-types'
    });
};

/**
 * Create a global required study type
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateRequiredStudyType = (data: ConfigMgmtControllerCreateRequiredStudyTypeData): CancelablePromise<ConfigMgmtControllerCreateRequiredStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/required-study-types',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requiredStudyTypeId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateRequiredStudyType = (data: ConfigMgmtControllerUpdateRequiredStudyTypeData): CancelablePromise<ConfigMgmtControllerUpdateRequiredStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/required-study-types/{requiredStudyTypeId}',
        path: {
            requiredStudyTypeId: data.requiredStudyTypeId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requiredStudyTypeId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerDeleteRequiredStudyType = (data: ConfigMgmtControllerDeleteRequiredStudyTypeData): CancelablePromise<ConfigMgmtControllerDeleteRequiredStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/required-study-types/{requiredStudyTypeId}',
        path: {
            requiredStudyTypeId: data.requiredStudyTypeId
        }
    });
};

/**
 * List all Tahseel 'Study Type' lookup entries (periodic/emergency, etc.)
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListTahseelStudyRequestTypes = (): CancelablePromise<ConfigMgmtControllerListTahseelStudyRequestTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/tahseel-study-request-types'
    });
};

/**
 * Create a Tahseel 'Study Type' lookup entry
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateTahseelStudyRequestType = (data: ConfigMgmtControllerCreateTahseelStudyRequestTypeData): CancelablePromise<ConfigMgmtControllerCreateTahseelStudyRequestTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/tahseel-study-request-types',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.tahseelStudyRequestTypeId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateTahseelStudyRequestType = (data: ConfigMgmtControllerUpdateTahseelStudyRequestTypeData): CancelablePromise<ConfigMgmtControllerUpdateTahseelStudyRequestTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/tahseel-study-request-types/{tahseelStudyRequestTypeId}',
        path: {
            tahseelStudyRequestTypeId: data.tahseelStudyRequestTypeId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.tahseelStudyRequestTypeId
 * @returns void
 * @throws ApiError
 */
export const configMgmtControllerDeleteTahseelStudyRequestType = (data: ConfigMgmtControllerDeleteTahseelStudyRequestTypeData): CancelablePromise<ConfigMgmtControllerDeleteTahseelStudyRequestTypeResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/tahseel-study-request-types/{tahseelStudyRequestTypeId}',
        path: {
            tahseelStudyRequestTypeId: data.tahseelStudyRequestTypeId
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListEnvPermitTypes = (data: ConfigMgmtControllerListEnvPermitTypesData): CancelablePromise<ConfigMgmtControllerListEnvPermitTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}/env-types',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateEnvPermitType = (data: ConfigMgmtControllerCreateEnvPermitTypeData): CancelablePromise<ConfigMgmtControllerCreateEnvPermitTypeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/request-types/{id}/env-types',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.subId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateEnvPermitType = (data: ConfigMgmtControllerUpdateEnvPermitTypeData): CancelablePromise<ConfigMgmtControllerUpdateEnvPermitTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}/env-types/{subId}',
        path: {
            id: data.id,
            subId: data.subId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerListEnvPermitCategories = (data: ConfigMgmtControllerListEnvPermitCategoriesData): CancelablePromise<ConfigMgmtControllerListEnvPermitCategoriesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/request-types/{id}/env-categories',
        path: {
            id: data.id
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerCreateEnvPermitCategory = (data: ConfigMgmtControllerCreateEnvPermitCategoryData): CancelablePromise<ConfigMgmtControllerCreateEnvPermitCategoryResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/request-types/{id}/env-categories',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.subId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const configMgmtControllerUpdateEnvPermitCategory = (data: ConfigMgmtControllerUpdateEnvPermitCategoryData): CancelablePromise<ConfigMgmtControllerUpdateEnvPermitCategoryResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/request-types/{id}/env-categories/{subId}',
        path: {
            id: data.id,
            subId: data.subId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List PledgeStudyType records
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyConfigControllerListPledgeStudyTypes = (): CancelablePromise<PledgeStudyConfigControllerListPledgeStudyTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/pledge-study/types'
    });
};

/**
 * Update PledgeStudyType fee config
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyConfigControllerUpdatePledgeStudyType = (data: PledgeStudyConfigControllerUpdatePledgeStudyTypeData): CancelablePromise<PledgeStudyConfigControllerUpdatePledgeStudyTypeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/pledge-study/types/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List MeasurementPointType records
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyConfigControllerListMeasurementPoints = (): CancelablePromise<PledgeStudyConfigControllerListMeasurementPointsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/pledge-study/measurement-points'
    });
};

/**
 * Create MeasurementPointType
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyConfigControllerCreateMeasurementPoint = (data: PledgeStudyConfigControllerCreateMeasurementPointData): CancelablePromise<PledgeStudyConfigControllerCreateMeasurementPointResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/pledge-study/measurement-points',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Update MeasurementPointType (unitPrice change does NOT affect existing PledgeStudy rows)
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const pledgeStudyConfigControllerUpdateMeasurementPoint = (data: PledgeStudyConfigControllerUpdateMeasurementPointData): CancelablePromise<PledgeStudyConfigControllerUpdateMeasurementPointResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/pledge-study/measurement-points/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List all API clients issued to external integrations (raw key never returned)
 * @returns unknown
 * @throws ApiError
 */
export const apiClientControllerList = (): CancelablePromise<ApiClientControllerListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/api-clients'
    });
};

/**
 * Issue a new API key — the raw key is returned exactly once
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const apiClientControllerCreate = (data: ApiClientControllerCreateData): CancelablePromise<ApiClientControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/api-clients',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Revoke an API client key — takes effect immediately
 * @param data The data for the request.
 * @param data.id
 * @returns unknown
 * @throws ApiError
 */
export const apiClientControllerRevoke = (data: ApiClientControllerRevokeData): CancelablePromise<ApiClientControllerRevokeResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/api-clients/{id}/revoke',
        path: {
            id: data.id
        }
    });
};

/**
 * List survey responses with filtering (ES_ADMIN only)
 * @param data The data for the request.
 * @param data.submitted true = submitted only, false = not yet submitted
 * @param data.permitTypeCode Filter by PermitType.code (ENV | WASTE | VEH)
 * @param data.dateFrom ISO date string — createdAt >= dateFrom
 * @param data.dateTo ISO date string — createdAt <= dateTo
 * @param data.page
 * @param data.limit
 * @returns unknown
 * @throws ApiError
 */
export const surveyControllerFindAll = (data: SurveyControllerFindAllData = {}): CancelablePromise<SurveyControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/survey/responses',
        query: {
            submitted: data.submitted,
            permitTypeCode: data.permitTypeCode,
            dateFrom: data.dateFrom,
            dateTo: data.dateTo,
            page: data.page,
            limit: data.limit
        }
    });
};

/**
 * Aggregated survey stats (ES_ADMIN only)
 * @returns unknown
 * @throws ApiError
 */
export const surveyControllerGetSummary = (): CancelablePromise<SurveyControllerGetSummaryResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/survey/responses/summary'
    });
};

/**
 * Get submitted survey for a specific permit (ES_ADMIN only)
 * @param data The data for the request.
 * @param data.permitId
 * @throws ApiError
 */
export const surveyControllerFindByPermitId = (data: SurveyControllerFindByPermitIdData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/survey/responses/{permitId}',
        path: {
            permitId: data.permitId
        },
        errors: {
            404: 'No submitted survey for this permit'
        }
    });
};

/**
 * Get survey questions for a token (public)
 * @param data The data for the request.
 * @param data.token
 * @throws ApiError
 */
export const surveyControllerGetByToken = (data: SurveyControllerGetByTokenData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/survey/{token}',
        path: {
            token: data.token
        },
        errors: {
            404: 'Token not found',
            410: 'Survey already submitted'
        }
    });
};

/**
 * Submit survey responses (public, idempotency-guarded)
 * @param data The data for the request.
 * @param data.token
 * @param data.requestBody
 * @returns unknown Submission accepted
 * @throws ApiError
 */
export const surveyControllerSubmit = (data: SurveyControllerSubmitData): CancelablePromise<SurveyControllerSubmitResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/survey/{token}',
        path: {
            token: data.token
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            410: 'Already submitted',
            422: 'Missing question answers'
        }
    });
};

/**
 * Health check — db and queue liveness
 * @returns unknown
 * @throws ApiError
 */
export const healthControllerCheck = (): CancelablePromise<HealthControllerCheckResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/health'
    });
};

/**
 * Submit an extension request for the study report deadline
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.requestBody
 * @returns unknown Extension request created
 * @throws ApiError
 */
export const extensionRequestsControllerCreate = (data: ExtensionRequestsControllerCreateData): CancelablePromise<ExtensionRequestsControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/extension-requests',
        path: {
            studyRequestId: data.studyRequestId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List all extension requests for a study request
 * @param data The data for the request.
 * @param data.studyRequestId
 * @returns unknown
 * @throws ApiError
 */
export const extensionRequestsControllerFindAll = (data: ExtensionRequestsControllerFindAllData): CancelablePromise<ExtensionRequestsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/extension-requests',
        path: {
            studyRequestId: data.studyRequestId
        }
    });
};

/**
 * Approve extension request — updates Request.reportSubmissionDate
 * If daysGranted is omitted, daysRequested is used as-is.
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.extId
 * @param data.requestBody
 * @throws ApiError
 */
export const extensionRequestsControllerApprove = (data: ExtensionRequestsControllerApproveData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/extension-requests/{extId}/approve',
        path: {
            studyRequestId: data.studyRequestId,
            extId: data.extId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Extension request is not in PENDING status'
        }
    });
};

/**
 * Reject extension request — mandatory comments required
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.extId
 * @param data.requestBody
 * @throws ApiError
 */
export const extensionRequestsControllerReject = (data: ExtensionRequestsControllerRejectData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/extension-requests/{extId}/reject',
        path: {
            studyRequestId: data.studyRequestId,
            extId: data.extId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Comments are required for rejection',
            422: 'Extension request is not in PENDING status'
        }
    });
};

/**
 * Create a lab test request
 * Sets parent study request status to REQUEST_LAB_TEST. Notifies all Lab Users via LAB_TEST_REQUESTED email.
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.requestBody
 * @returns unknown Lab request created
 * @throws ApiError
 */
export const labRequestsControllerCreate = (data: LabRequestsControllerCreateData): CancelablePromise<LabRequestsControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests',
        path: {
            studyRequestId: data.studyRequestId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List lab requests for a study request
 * @param data The data for the request.
 * @param data.studyRequestId
 * @returns unknown
 * @throws ApiError
 */
export const labRequestsControllerFindAll = (data: LabRequestsControllerFindAllData): CancelablePromise<LabRequestsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests',
        path: {
            studyRequestId: data.studyRequestId
        }
    });
};

/**
 * Self-assign a lab request (must be PENDING_LAB_ASSIGNMENT)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @throws ApiError
 */
export const labRequestsControllerAssignToMe = (data: LabRequestsControllerAssignToMeData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/assign-to-me',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId
        },
        errors: {
            409: 'Already assigned to another technician',
            422: 'Lab request is not PENDING_LAB_ASSIGNMENT'
        }
    });
};

/**
 * Schedule a Lab Site Visit for this lab request
 * Only the assigned Lab Technician may create this; one visit per lab request.
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @param data.requestBody
 * @throws ApiError
 */
export const labRequestsControllerCreateSiteVisit = (data: LabRequestsControllerCreateSiteVisitData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/site-visit',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            403: 'Not the assigned Lab Technician',
            409: 'Lab request already has a site visit'
        }
    });
};

/**
 * Create a lab report (status: DRAFT)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const labRequestsControllerCreateReport = (data: LabRequestsControllerCreateReportData): CancelablePromise<LabRequestsControllerCreateReportResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/reports',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Update lab report name, comments, or status (DRAFT only; use /submit for SUBMITTED)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @param data.reportId
 * @param data.requestBody
 * @throws ApiError
 */
export const labRequestsControllerUpdateReport = (data: LabRequestsControllerUpdateReportData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/reports/{reportId}',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId,
            reportId: data.reportId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Report is already submitted'
        }
    });
};

/**
 * Submit a lab report
 * Changes status from DRAFT to SUBMITTED and notifies the Beeah Consultant.
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @param data.reportId
 * @throws ApiError
 */
export const labRequestsControllerSubmitReport = (data: LabRequestsControllerSubmitReportData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/reports/{reportId}/submit',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId,
            reportId: data.reportId
        },
        errors: {
            422: 'Report is already submitted, or has no attachments'
        }
    });
};

/**
 * Upload lab report attachment
 * Accepted types: PDF, DOCX, JPEG, PNG. Max size from MAX_FILE_SIZE_MB env.
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @param data.reportId
 * @throws ApiError
 */
export const labRequestsControllerUploadAttachment = (data: LabRequestsControllerUploadAttachmentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/reports/{reportId}/attachments',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId,
            reportId: data.reportId
        },
        errors: {
            400: 'No file uploaded or invalid type'
        }
    });
};

/**
 * Delete a lab report attachment (blocked once submitted)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @param data.reportId
 * @param data.attachmentId
 * @returns void
 * @throws ApiError
 */
export const labRequestsControllerDeleteAttachment = (data: LabRequestsControllerDeleteAttachmentData): CancelablePromise<LabRequestsControllerDeleteAttachmentResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/reports/{reportId}/attachments/{attachmentId}',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId,
            reportId: data.reportId,
            attachmentId: data.attachmentId
        }
    });
};

/**
 * Get a 15-minute presigned download URL for a lab report attachment
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.labId
 * @param data.reportId
 * @param data.attachmentId
 * @returns unknown Returns presigned download URL
 * @throws ApiError
 */
export const labRequestsControllerGetAttachmentDownloadUrl = (data: LabRequestsControllerGetAttachmentDownloadUrlData): CancelablePromise<LabRequestsControllerGetAttachmentDownloadUrlResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/lab-requests/{labId}/reports/{reportId}/attachments/{attachmentId}/download',
        path: {
            studyRequestId: data.studyRequestId,
            labId: data.labId,
            reportId: data.reportId,
            attachmentId: data.attachmentId
        },
        errors: {
            404: 'Attachment not found'
        }
    });
};

/**
 * Aggregate lab request stats for the dashboard, across every study request
 * @returns unknown
 * @throws ApiError
 */
export const allLabRequestsControllerGetDashboardStats = (): CancelablePromise<AllLabRequestsControllerGetDashboardStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/lab-requests/dashboard-stats'
    });
};

/**
 * Create a site visit for a study request
 * @param data The data for the request.
 * @param data.studyRequestId Study request ID
 * @param data.requestBody
 * @returns unknown Site visit created
 * @throws ApiError
 */
export const siteVisitsControllerCreate = (data: SiteVisitsControllerCreateData): CancelablePromise<SiteVisitsControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/site-visits',
        path: {
            studyRequestId: data.studyRequestId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List site visits for a study request, grouped by visitType
 * @param data The data for the request.
 * @param data.studyRequestId Study request ID
 * @returns unknown
 * @throws ApiError
 */
export const siteVisitsControllerFindAll = (data: SiteVisitsControllerFindAllData): CancelablePromise<SiteVisitsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/site-visits',
        path: {
            studyRequestId: data.studyRequestId
        }
    });
};

/**
 * Submit site visit for customer approval
 * Sets status to CUSTOMER_APPROVAL, generates an approval token, and sends customer a notification with approve/reschedule URLs. Also advances parent request status to SITE_VISIT_SCHEDULED if not already past it.
 * @param data The data for the request.
 * @param data.studyRequestId Study request ID
 * @param data.visitId Site visit ID
 * @returns unknown
 * @throws ApiError
 */
export const siteVisitsControllerSubmitForApproval = (data: SiteVisitsControllerSubmitForApprovalData): CancelablePromise<SiteVisitsControllerSubmitForApprovalResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{studyRequestId}/site-visits/{visitId}/submit-for-approval',
        path: {
            studyRequestId: data.studyRequestId,
            visitId: data.visitId
        }
    });
};

/**
 * Start site visit (must be APPROVED)
 * @param data The data for the request.
 * @param data.studyRequestId Study request ID
 * @param data.visitId Site visit ID
 * @throws ApiError
 */
export const siteVisitsControllerStart = (data: SiteVisitsControllerStartData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{studyRequestId}/site-visits/{visitId}/start',
        path: {
            studyRequestId: data.studyRequestId,
            visitId: data.visitId
        },
        errors: {
            422: 'Status is not APPROVED'
        }
    });
};

/**
 * Reschedule a site visit (requires a reason)
 * @param data The data for the request.
 * @param data.studyRequestId Study request ID
 * @param data.visitId Site visit ID
 * @param data.requestBody
 * @throws ApiError
 */
export const siteVisitsControllerReschedule = (data: SiteVisitsControllerRescheduleData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{studyRequestId}/site-visits/{visitId}/reschedule',
        path: {
            studyRequestId: data.studyRequestId,
            visitId: data.visitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Visit is already COMPLETED'
        }
    });
};

/**
 * Complete site visit (must be IN_PROGRESS)
 * @param data The data for the request.
 * @param data.studyRequestId Study request ID
 * @param data.visitId Site visit ID
 * @param data.requestBody
 * @throws ApiError
 */
export const siteVisitsControllerComplete = (data: SiteVisitsControllerCompleteData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{studyRequestId}/site-visits/{visitId}/complete',
        path: {
            studyRequestId: data.studyRequestId,
            visitId: data.visitId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Status is not IN_PROGRESS'
        }
    });
};

/**
 * Get site visit details for customer approval (public)
 * Returns visit details for display. Returns 409 if already decided, 410 if expired.
 * @param data The data for the request.
 * @param data.token Approval token from the customer notification email
 * @returns unknown Site visit details
 * @throws ApiError
 */
export const siteVisitTokenControllerGetByToken = (data: SiteVisitTokenControllerGetByTokenData): CancelablePromise<SiteVisitTokenControllerGetByTokenResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/site-visits/approval/{token}',
        path: {
            token: data.token
        },
        errors: {
            404: 'Token not found',
            409: 'Already approved or rescheduled',
            410: 'Token expired'
        }
    });
};

/**
 * Customer approves site visit via token (public)
 * Token expires 24 hours after generation. Returns 410 if expired.
 * @param data The data for the request.
 * @param data.token Approval token from the customer notification email
 * @returns unknown Site visit approved
 * @throws ApiError
 */
export const siteVisitTokenControllerApprove = (data: SiteVisitTokenControllerApproveData): CancelablePromise<SiteVisitTokenControllerApproveResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/site-visits/approve/{token}',
        path: {
            token: data.token
        },
        errors: {
            404: 'Token not found',
            409: 'Already approved or no longer awaiting approval',
            410: 'Token expired'
        }
    });
};

/**
 * Customer requests reschedule via token (public)
 * Token expires 24 hours after generation. Returns 410 if expired.
 * @param data The data for the request.
 * @param data.token Approval token from the customer notification email
 * @param data.requestBody
 * @returns unknown Reschedule request submitted
 * @throws ApiError
 */
export const siteVisitTokenControllerReschedule = (data: SiteVisitTokenControllerRescheduleData): CancelablePromise<SiteVisitTokenControllerRescheduleResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/site-visits/reschedule/{token}',
        path: {
            token: data.token
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Token not found',
            410: 'Token expired'
        }
    });
};

/**
 * List all site visits across study requests, filtered by the caller's user type
 * @returns unknown
 * @throws ApiError
 */
export const mySiteVisitsControllerFindMine = (): CancelablePromise<MySiteVisitsControllerFindMineResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/site-visits/mine'
    });
};

/**
 * List every site visit across every study request, regardless of type or assignment
 * @returns unknown
 * @throws ApiError
 */
export const allSiteVisitsControllerFindAll = (): CancelablePromise<AllSiteVisitsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/site-visits'
    });
};

/**
 * Save a new study report draft (does not notify or change parent status)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.requestBody
 * @returns unknown Study report draft created
 * @throws ApiError
 */
export const studyReportsControllerCreate = (data: StudyReportsControllerCreateData): CancelablePromise<StudyReportsControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports',
        path: {
            studyRequestId: data.studyRequestId
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * List study reports for a study request
 * @param data The data for the request.
 * @param data.studyRequestId
 * @returns unknown
 * @throws ApiError
 */
export const studyReportsControllerFindAll = (data: StudyReportsControllerFindAllData): CancelablePromise<StudyReportsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports',
        path: {
            studyRequestId: data.studyRequestId
        }
    });
};

/**
 * Submit study report for SM approval (requires at least one attachment; sets parent status to STUDY_REPORT_SM_APPROVAL)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @throws ApiError
 */
export const studyReportsControllerSubmit = (data: StudyReportsControllerSubmitData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/submit',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        },
        errors: {
            422: 'Report is not editable or has no attachment'
        }
    });
};

/**
 * Get study report detail with attachments and approval history
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @returns unknown
 * @throws ApiError
 */
export const studyReportsControllerFindOne = (data: StudyReportsControllerFindOneData): CancelablePromise<StudyReportsControllerFindOneResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        }
    });
};

/**
 * Update study report (only allowed when DRAFT or REJECTED)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @param data.requestBody
 * @throws ApiError
 */
export const studyReportsControllerUpdate = (data: StudyReportsControllerUpdateData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Report is not in an editable status'
        }
    });
};

/**
 * Upload study report attachment (PDF, DOCX, JPG, PNG)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @throws ApiError
 */
export const studyReportsControllerUploadAttachment = (data: StudyReportsControllerUploadAttachmentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/attachments',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        },
        errors: {
            400: 'No file or invalid file type'
        }
    });
};

/**
 * Delete a study report attachment (only while report is editable)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @param data.attachmentId
 * @throws ApiError
 */
export const studyReportsControllerDeleteAttachment = (data: StudyReportsControllerDeleteAttachmentData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/attachments/{attachmentId}',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId,
            attachmentId: data.attachmentId
        },
        errors: {
            404: 'Attachment not found',
            422: 'Report is not in an editable status'
        }
    });
};

/**
 * Approve study report — moves request to PAYMENT_PROCESS and creates payment link
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @param data.requestBody
 * @throws ApiError
 */
export const studyReportsControllerApprove = (data: StudyReportsControllerApproveData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/approve',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Report is already approved or not in WAITING_FOR_APPROVAL status'
        }
    });
};

/**
 * Reject study report — moves request to REJECTED and notifies consultant with comments
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @param data.requestBody
 * @throws ApiError
 */
export const studyReportsControllerReject = (data: StudyReportsControllerRejectData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/reject',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Comments are required for rejection',
            422: 'Report is already rejected or not in WAITING_FOR_APPROVAL status'
        }
    });
};

/**
 * Get full approval cycle history for a study report
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @returns unknown
 * @throws ApiError
 */
export const studyReportsControllerFindApprovals = (data: StudyReportsControllerFindApprovalsData): CancelablePromise<StudyReportsControllerFindApprovalsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/approvals',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        }
    });
};

/**
 * Get a 15-minute presigned download URL for a study report attachment
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @param data.attachmentId
 * @returns unknown Returns presigned download URL
 * @throws ApiError
 */
export const studyReportsControllerGetAttachmentDownloadUrl = (data: StudyReportsControllerGetAttachmentDownloadUrlData): CancelablePromise<StudyReportsControllerGetAttachmentDownloadUrlResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/attachments/{attachmentId}/download',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId,
            attachmentId: data.attachmentId
        },
        errors: {
            404: 'Attachment not found'
        }
    });
};

/**
 * Get a presigned download URL for the Environmental Study Contract letter — generated once the report is APPROVED, cached thereafter
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.reportId
 * @returns unknown Returns presigned download URL
 * @throws ApiError
 */
export const studyReportsControllerGetEnvironmentalStudyContractUrl = (data: StudyReportsControllerGetEnvironmentalStudyContractUrlData): CancelablePromise<StudyReportsControllerGetEnvironmentalStudyContractUrlResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/study-reports/{reportId}/environmental-study-contract',
        path: {
            studyRequestId: data.studyRequestId,
            reportId: data.reportId
        },
        errors: {
            422: 'Study report is not yet approved'
        }
    });
};

/**
 * List all study reports across every study request
 * @returns unknown
 * @throws ApiError
 */
export const allStudyReportsControllerFindAll = (): CancelablePromise<AllStudyReportsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-reports'
    });
};

/**
 * Create a study request manually
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Study request created
 * @throws ApiError
 */
export const studyRequestsControllerCreate = (data: StudyRequestsControllerCreateData): CancelablePromise<StudyRequestsControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'SM_STUDY request type not seeded'
        }
    });
};

/**
 * List study requests scoped to SHARJAH_MUNICIPALITY
 * Supports filtering by status, assignedConsultantId, and folder (COMPLETED_STUDIES / IN_PROGRESS_WITH_LAB / UNDER_REVIEW).
 * @param data The data for the request.
 * @param data.status
 * @param data.statuses Comma-separated list of statuses (OR match)
 * @param data.folder
 * @param data.assignedConsultantId Filter by assigned consultant ID
 * @param data.authorityAssigneeId Filter by SM Consultant Authority assignee ID
 * @param data.unassignedAuthorityOnly When "true", only return requests with no authority assignee set yet
 * @param data.search Full-text search on reference no, account name, or TRN (partial match)
 * @param data.page
 * @param data.limit
 * @returns unknown
 * @throws ApiError
 */
export const studyRequestsControllerFindAll = (data: StudyRequestsControllerFindAllData = {}): CancelablePromise<StudyRequestsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests',
        query: {
            status: data.status,
            statuses: data.statuses,
            folder: data.folder,
            assignedConsultantId: data.assignedConsultantId,
            authorityAssigneeId: data.authorityAssigneeId,
            unassignedAuthorityOnly: data.unassignedAuthorityOnly,
            search: data.search,
            page: data.page,
            limit: data.limit
        }
    });
};

/**
 * Simulate a Tahseel inbound request (Dev/QA only)
 * Builds a synthetic Tahseel payload and runs it through the real inbound flow. Returns 404 in production.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Mock study request created
 * @throws ApiError
 */
export const studyRequestsControllerMockTahseelRequest = (data: StudyRequestsControllerMockTahseelRequestData): CancelablePromise<StudyRequestsControllerMockTahseelRequestResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/mock-tahseel-request',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Disabled in production'
        }
    });
};

/**
 * Preview study fee without creating a record
 * Returns the fee breakdown for a given study type and optional measurement point selections.
 * @returns unknown Fee breakdown
 * @throws ApiError
 */
export const studyRequestsControllerFeePreview = (): CancelablePromise<StudyRequestsControllerFeePreviewResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/fee-preview',
        errors: {
            404: 'Study type or measurement point type not found'
        }
    });
};

/**
 * Aggregate study request stats for the dashboard (MTD counts, monthly trend, pipeline)
 * @returns unknown
 * @throws ApiError
 */
export const studyRequestsControllerGetDashboardStats = (): CancelablePromise<StudyRequestsControllerGetDashboardStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/dashboard-stats'
    });
};

/**
 * Get study request detail including related entities
 * @param data The data for the request.
 * @param data.id Study request ID
 * @throws ApiError
 */
export const studyRequestsControllerFindOne = (data: StudyRequestsControllerFindOneData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{id}',
        path: {
            id: data.id
        },
        errors: {
            404: 'Study request not found'
        }
    });
};

/**
 * Assign a Beeah Consultant and move status to ASSIGNED
 * @param data The data for the request.
 * @param data.id Study request ID
 * @param data.requestBody
 * @returns unknown Consultant assigned
 * @throws ApiError
 */
export const studyRequestsControllerAssignConsultant = (data: StudyRequestsControllerAssignConsultantData): CancelablePromise<StudyRequestsControllerAssignConsultantResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{id}/assign-consultant',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Study request or consultant not found'
        }
    });
};

/**
 * Assign an SM Consultant Authority Assignee
 * @param data The data for the request.
 * @param data.id Study request ID
 * @param data.requestBody
 * @returns unknown Authority assignee set
 * @throws ApiError
 */
export const studyRequestsControllerAssignAuthority = (data: StudyRequestsControllerAssignAuthorityData): CancelablePromise<StudyRequestsControllerAssignAuthorityResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{id}/assign-authority',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            404: 'Study request or authority assignee not found'
        }
    });
};

/**
 * Trigger SAP sync for a study request
 * @param data The data for the request.
 * @param data.id Study request ID
 * @returns unknown SAP sync queued
 * @throws ApiError
 */
export const studyRequestsControllerSendToSap = (data: StudyRequestsControllerSendToSapData): CancelablePromise<StudyRequestsControllerSendToSapResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{id}/send-to-sap',
        path: {
            id: data.id
        }
    });
};

/**
 * Get audit log for a study request
 * @param data The data for the request.
 * @param data.id Study request ID
 * @returns unknown
 * @throws ApiError
 */
export const studyRequestsControllerGetAuditLog = (data: StudyRequestsControllerGetAuditLogData): CancelablePromise<StudyRequestsControllerGetAuditLogResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{id}/audit',
        path: {
            id: data.id
        }
    });
};

/**
 * Issue final report
 * Valid only when status is PAID. Sets status to FINAL_REPORT_ISSUED, creates a survey token, and notifies the contact.
 * @param data The data for the request.
 * @param data.id Study request ID
 * @returns unknown Final report issued
 * @throws ApiError
 */
export const studyRequestsControllerIssueFinalReport = (data: StudyRequestsControllerIssueFinalReportData): CancelablePromise<StudyRequestsControllerIssueFinalReportResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/study-requests/{id}/issue-final-report',
        path: {
            id: data.id
        },
        errors: {
            422: 'Status is not PAID'
        }
    });
};

/**
 * List document types available for municipality attachments
 * @param data The data for the request.
 * @param data.studyRequestId
 * @returns unknown
 * @throws ApiError
 */
export const studyDocumentsControllerListDocumentTypes = (data: StudyDocumentsControllerListDocumentTypesData): CancelablePromise<StudyDocumentsControllerListDocumentTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/documents/types',
        path: {
            studyRequestId: data.studyRequestId
        }
    });
};

/**
 * Upload a municipality attachment
 * Accepted types: PDF, DOCX, JPEG, PNG (verified by magic bytes). Max size: 10 MB. documentTypeId must be one of the study-specific document types (see GET /types).
 * @param data The data for the request.
 * @param data.studyRequestId
 * @throws ApiError
 */
export const studyDocumentsControllerUpload = (data: StudyDocumentsControllerUploadData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/{studyRequestId}/documents',
        path: {
            studyRequestId: data.studyRequestId
        },
        errors: {
            400: 'No file, invalid file type, or invalid document type',
            422: 'File size exceeds 10 MB'
        }
    });
};

/**
 * List municipality attachments with signed download URLs (15 min TTL)
 * @param data The data for the request.
 * @param data.studyRequestId
 * @returns unknown
 * @throws ApiError
 */
export const studyDocumentsControllerFindAll = (data: StudyDocumentsControllerFindAllData): CancelablePromise<StudyDocumentsControllerFindAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/{studyRequestId}/documents',
        path: {
            studyRequestId: data.studyRequestId
        }
    });
};

/**
 * Soft-delete a municipality attachment
 * @param data The data for the request.
 * @param data.studyRequestId
 * @param data.docId
 * @throws ApiError
 */
export const studyDocumentsControllerDelete = (data: StudyDocumentsControllerDeleteData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/study-requests/{studyRequestId}/documents/{docId}',
        path: {
            studyRequestId: data.studyRequestId,
            docId: data.docId
        },
        errors: {
            404: 'Document not found'
        }
    });
};

/**
 * Receive inbound study request from Tahseel (Sharjah Municipality)
 * Creates or upserts an Account and Contact, then creates a linked study request. Secured by X-Api-Key header — the key must carry the 'tahseel-inbound:receive' scope. Idempotent: duplicate ReferenceNumber returns the existing record. Always logs the raw payload to TahseelInboundLog.
 * @param data The data for the request.
 * @param data.xApiKey Tahseel API key
 * @returns unknown Study request created or already exists
 * @throws ApiError
 */
export const tahseelInboundControllerReceive = (data: TahseelInboundControllerReceiveData): CancelablePromise<TahseelInboundControllerReceiveResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/inbound/tahseel',
        headers: {
            'X-Api-Key': data.xApiKey
        },
        errors: {
            400: 'Validation error — see errors field',
            401: 'Missing, invalid, revoked, or expired API key',
            403: 'API key does not have the required scope'
        }
    });
};

/**
 * List every Tahseel inbound log, newest first
 * @returns unknown
 * @throws ApiError
 */
export const tahseelInboundControllerListAll = (): CancelablePromise<TahseelInboundControllerListAllResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/inbound/logs'
    });
};

/**
 * Full detail for one Tahseel inbound log, including the raw payload
 * @param data The data for the request.
 * @param data.logId
 * @throws ApiError
 */
export const tahseelInboundControllerFindLogById = (data: TahseelInboundControllerFindLogByIdData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/study-requests/inbound/logs/{logId}',
        path: {
            logId: data.logId
        },
        errors: {
            404: 'Log not found'
        }
    });
};

/**
 * Manually create the Account/Contact/Request from a stored Tahseel payload
 * @param data The data for the request.
 * @param data.logId
 * @returns unknown Request created (or already existed) successfully
 * @throws ApiError
 */
export const tahseelInboundControllerCreateRequestFromLog = (data: TahseelInboundControllerCreateRequestFromLogData): CancelablePromise<TahseelInboundControllerCreateRequestFromLogResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/study-requests/inbound/logs/{logId}/create-request',
        path: {
            logId: data.logId
        },
        errors: {
            404: 'Log not found',
            409: 'Log already has a request'
        }
    });
};

/**
 * List all user types
 * @returns unknown
 * @throws ApiError
 */
export const userTypesControllerList = (): CancelablePromise<UserTypesControllerListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/config/user-types'
    });
};

/**
 * Create a user type (code auto-generated)
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const userTypesControllerCreate = (data: UserTypesControllerCreateData): CancelablePromise<UserTypesControllerCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/config/user-types',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown
 * @throws ApiError
 */
export const userTypesControllerUpdate = (data: UserTypesControllerUpdateData): CancelablePromise<UserTypesControllerUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/config/user-types/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.id
 * @returns void
 * @throws ApiError
 */
export const userTypesControllerSoftDelete = (data: UserTypesControllerSoftDeleteData): CancelablePromise<UserTypesControllerSoftDeleteResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/config/user-types/{id}',
        path: {
            id: data.id
        }
    });
};